import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { environment } from 'environments/environment';
import { AccountsService } from '~/services/administration.ts/accounts';
import { ReportsService } from '~/services/modules/reports/reports';
import { ThemeManagerService } from '~/services/theme-manager';
import { LazyLoadingLibraryService } from '~/modules/stocks/reports/report/LazyLoadingLibraryService';
import { _getShadowRoot } from '@angular/cdk/platform';
import { GridFieldSummary } from '~/models/modules/gridField';
import { LabelService } from '~/services/modules/stocks/labels';
import { FilterCriteria, FilterDataService } from '~/services/filter-data.service';
import { FormatService } from '~/services/administration.ts/format';
import { LabelPreset } from '~/models/modules/labelPreset';
import { SendReportEmailModel } from '~/models/modules/SendReportEmailModel';
import { LayoutComponent } from '../layout/layout.component';
import { ZeroQuantitySettingsService } from '~/services/administration.ts/zero-quantity-settings';
import { MultiSiteService } from '~/services/modules/common/multi-site.service';
import { EnvironmentLoaderService } from '~/services/BackEndURL/environment-loader.service';

@Component({
    selector: 'report-viewer',
    templateUrl: './reportviewer.html',
    styleUrls: ['./reportviewer.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})

export class ReportViewerComponent implements OnInit, OnChanges {
  _active: boolean = true;
  _windowMode: boolean = true;
  _reportId: number;
  _selectedReportFields: GridFieldSummary[] = [];
  _selectedReportNotDateFields: GridFieldSummary[] = [];
  _selectedReportDateFields: GridFieldSummary[] = [];
  _selectedReportSortFields: GridFieldSummary[] = [];
  _showFilter: boolean = false;
  _showEmail: boolean = false;
  _siteId: number = null;

  _reportObject: any;
  _definitionOnly: any;
  _transactionId: any;
  _selectedFields: any;
  theme: string;
  opened: boolean = false;
  reportFileLoaded = false;
  viewerFileLoaded = false;
  designerFileLoaded = false;
  viewer: Stimulsoft.Viewer.StiViewer;
  stimulsoftReport: any;
  dbReport: any;
  public dataSet: any;
  public dataSetFinal: any;
  options: any;

  public providedDateValue: Date = null;
  public ForecastDateValue: Date = null;

  public listaccounts: any = [];

  public editForm: FormGroup;

  @Input() reportId: number;
  @Input() selectedReportFields: GridFieldSummary[];
  @Input() showFilter: boolean = false;
  @Input() showEmail: boolean = false;
  @Input() siteId: number = null;
  @Input() windowMode: boolean;
  @Input() reportObject: any;
  @Input() definitionOnly: any;
  @Input() reportParent?: string = '';
  @Input() transactionId: any;
  @Input() barcodeModel: any;
  @Input() previewMode: boolean = false;
  @Input() isCatalog: boolean = false;
  @Output() closeForm: EventEmitter<any> = new EventEmitter();
  @Output() maximizeWindow: EventEmitter<any> = new EventEmitter();
  @Output() returnDefinition: EventEmitter<any> = new EventEmitter();

  //////////// show filter fields
  //#region show filter fields
  selectedSortField: any;
  filterValue: any;
  reportGridFields: GridFieldSummary[] = [];
  allReportData: any[];
  filteredReportData: any = [] = [];
  filterCriteriaHtml: any[] = [{
    field: {},
    operator: {},
    value: ''
  },
  {
    field: {},
    operator: {},
    value: ''
  },
  {
    field: {},
    operator: {},
    value: ''
  },
  ];
  filterType: any =
    [
      { type: 'EQUAL TO' },
      { type: 'NOT EQUAL TO' },
      { type: 'GREATER THAN' },
      { type: 'BETWEEN' },
      { type: 'LIKE' },
      { type: 'IN' },
      { type: 'NOT IN' },
    ];
  operators: any =
    [
      { operator: 'AND' },
      { operator: 'OR' },
    ];

  filterTypeValue: any;
  isFilterVisible: boolean = false;
  dateRangeFilter: boolean = false;
  dataFieldFilter: boolean = false;
  reportSorting: boolean = false;
  _datePickerFormat: string;
  fromDateRange: any;
  toDateRange: any;
  dateRangeFilterField: any;
  _selectedCheckBoxesSortFields: GridFieldSummary[] = [];
  //#endregion
  ///////////////

  //#region Show Email Fields
  isShowEmailVisible: boolean = false;
  emailsToSend: string = "";
  //#endregion

  constructor(private _themeManager: ThemeManagerService,
    private _lazyLoadingLibraryService: LazyLoadingLibraryService,
    private _reportService: ReportsService,
    private formBuilder: FormBuilder,
    private _zeroQuantitySettingsService: ZeroQuantitySettingsService,
    private _accountService: AccountsService,
    // @Inject(PORTAL_DATA) public data: any
    private _labelsService: LabelService,
    private _filterService: FilterDataService,
    private _formatService: FormatService,
    private _layoutComponent: LayoutComponent,
    private _multiSiteService: MultiSiteService) {

    this.editForm = this.formBuilder.group({
      overage: new FormControl(),
      replenish: new FormControl(),
      selectedAccount: new FormControl(),
      conditionName: new FormControl(null),
      initialValue: new FormControl(),
      targetedValue: new FormControl(),
      ForecastDate: new FormControl(this.ForecastDateValue),
      providedDate: new FormControl(this.providedDateValue),
      withBurnRate: new FormControl(),
    });
    this._themeManager.themeChange.subscribe((data: any) => {
      this.theme = data;
    });

    const isAnonymous = location.pathname.toLowerCase().includes('renderreport');
    if (!isAnonymous) {
      _accountService.getAccountsListing().subscribe(
        (x: any) => {
          this.listaccounts = x;
        }
      );
    }
  }

  //#region Show Email Options
  isWhitespace(value: string): boolean {
    // Use trim() to remove leading and trailing whitespace, then check if the resulting string is not empty
    if (typeof value === 'string') {
      var test = value.trim() == '';
      return value.trim() == '';
    }
  }

  toggleEmail() {
    this.isShowEmailVisible = !this.isShowEmailVisible;
  }

  sendEmail(emails: string) {
    if (!emails || this.isWhitespace(emails)) {
      this._layoutComponent.openPopup({
        title: 'Validation',
        message: 'Please write one email at least',
        returnAfterOkCloseClick: true,
        withoutConfirm: true,
      });

      return;
    }
    // Retrieve report data and other necessary information
    var pdfBytes = this.viewer.report.exportDocument(Stimulsoft.Report.StiExportFormat.Pdf);
    //   alert(pdfBytes);

    let binaryString = '';
    for (let i = 0; i < pdfBytes.length; i++) {
      binaryString += String.fromCharCode(pdfBytes[i] as number);
    }
    // Encode the binary string as base64
    const base64String = btoa(binaryString);
    let EmailsList = emails.split(",");
    const emailData: SendReportEmailModel = {
      emails: EmailsList,
      report: base64String,
      fileName: this.dbReport.name
    };
    this._reportService.sendEmail(emailData).subscribe((response) => {
      this._layoutComponent.openPopup({
        title: 'Alert',
        message: response.message,
        withoutConfirm: true
      });
    },
      // (error) => {
      //   alert('Email sending failed');
      // }
    );
  }
  //#endregion
  //#region Show Filter Options
  toggleFilter() {
    this.isFilterVisible = !this.isFilterVisible;
  }
  applySortingAndFiltering(sortBy: string, filterBy: string) {
    this.stimulsoftReport = new Stimulsoft.Report.StiReport();
    this.stimulsoftReport.loadEncryptedReport(this.dbReport.definition, environment.reportsKey);
    this.filteredReportData = [...this.allReportData];

    if (this.dateRangeFilter) // Date Range Filter
    {
      if (this.fromDateRange && this.toDateRange && this.dateRangeFilterField)
        this.filteredReportData = this.filterItemsByDateRange(this.filteredReportData, this.fromDateRange, this.toDateRange, this.dateRangeFilterField.field);
      // else
      // this.filteredReportData = [...this.allReportData];
    }

    if (this.dataFieldFilter) // Data Field Filter
    {
      let FilterCriteria: FilterCriteria[] = [];
      this.filterCriteriaHtml.forEach(element => {
        let obj: FilterCriteria = {
          field: element.field?.field,
          operator: element.operator?.type,
          value: element.value,
          logicalOperator: element.logicalOperator?.operator ?? "AND",
        }
        if (obj.field && obj.operator && obj.value)
          FilterCriteria.push(obj);
      });
      if (FilterCriteria.length > 0)
        this.filteredReportData = this._filterService.filter(this.filteredReportData, FilterCriteria);
    }

    if (this.reportSorting) // Report Sorting
    {
      let sortByCriteriaList: any[] = [];
      this._selectedReportSortFields.forEach(element => {
        var sortingCriteriaObject =
        {
          field: element.field,
          order: this._selectedCheckBoxesSortFields.filter((x: GridFieldSummary) => x.field == element.field).length > 0 ? 'desc' : 'asc'
        };
        sortByCriteriaList.push(sortingCriteriaObject);
      });
      if (sortByCriteriaList.length > 0) {
        this.filteredReportData = this.sortByMultipleFields(this.filteredReportData, sortByCriteriaList);;
      }
    }

    this.dataSet = new Stimulsoft.System.Data.DataSet('DataSet');

    this.dataSet.readJson(this.filteredReportData);

    this.stimulsoftReport.regData(this.dataSet.dataSetName, '', this.dataSet);
    this.stimulsoftReport.dictionary.synchronize();
    this.updateReportLogoAndAddress();
    this.viewer = new Stimulsoft.Viewer.StiViewer(
      this.options,
      'StiViewer',
      false
    );
    this.viewer.report = this.stimulsoftReport;
    this.viewer.renderHtml('viewer');



  }
  clearFiltering() {
    //#region Clear Date Range Filter Data
    this.fromDateRange = undefined;
    this.toDateRange = undefined;
    this.dateRangeFilterField = this._selectedReportDateFields && this._selectedReportDateFields.length > 0 ? this._selectedReportDateFields[0] : undefined;
    this.dateRangeFilter = false;
    //#endregion

    //#region Clear Date Field Filter Data
    this.filterCriteriaHtml = [{
      field: this._selectedReportNotDateFields && this._selectedReportNotDateFields.length > 0 ? this._selectedReportNotDateFields[0] : undefined,
      operator: {},
      value: '',
      logicalOperator: this.operators[0]
    },
    {
      field: this._selectedReportNotDateFields && this._selectedReportNotDateFields.length > 0 ? this._selectedReportNotDateFields[0] : undefined,
      operator: {},
      value: '',
      logicalOperator: this.operators[0]
    },
    {
      field: this._selectedReportNotDateFields && this._selectedReportNotDateFields.length > 0 ? this._selectedReportNotDateFields[0] : undefined,
      operator: {},
      value: '',
      logicalOperator: this.operators[0]
    },
    ]
    this.dataFieldFilter = false;
    //#endregion
    //#region Clear Date Range Filter Data
    this._selectedReportSortFields = [];
    this.reportSorting = false;
    //#endregion


    this.stimulsoftReport = new Stimulsoft.Report.StiReport();
    this.stimulsoftReport.loadEncryptedReport(
      this.dbReport.definition,
      environment.reportsKey
    );

    this.dataSet = new Stimulsoft.System.Data.DataSet('DataSet');
    let allReportDataCopy = [...this.allReportData];
    this.dataSet.readJson(allReportDataCopy);

    this.stimulsoftReport.regData(this.dataSet.dataSetName, '', this.dataSet);

    this.stimulsoftReport.dictionary.synchronize();
    this.updateReportLogoAndAddress();

    this.viewer = new Stimulsoft.Viewer.StiViewer(this.options, 'StiViewer', false);
    this.viewer.report = this.stimulsoftReport;
    this.viewer.renderHtml('viewer');
  }

  filterItemsByDateRange(items: any[], startDate: Date, endDate: Date, field: string): any[] {
    startDate = new Date(startDate);
    endDate = new Date(endDate);
    var itemsCopy = [...items];

    itemsCopy.forEach(element => {
      element[field] = element[field] ? new Date(element[field]) : element[field];
    });

    var DateFilter = itemsCopy.filter((item) => item[field] >= startDate && item[field] <= endDate);

    return DateFilter;
  }

  _onChangeSortSelectedFields(event: any) {
    this._selectedReportSortFields = event;
  }

  getCustomCheckBoxSelected(event: any) {
    this._selectedCheckBoxesSortFields = event;
  }

  dynamicSort(property: string, sortOrder: 'asc' | 'desc' = 'asc') {
    return function (a: any, b: any) {
      const aValue = a[property];
      const bValue = b[property];

      if (aValue < bValue) {
        return sortOrder === 'asc' ? -1 : 1;
      }
      else if (aValue > bValue) {
        return sortOrder === 'asc' ? 1 : -1;
      }
      else {
        return 0;
      }
    };
  }

  sortByMultipleFields(data: any[], sortingCriteria: { field: string; order: 'asc' | 'desc' }[]) {
    return data.sort((a, b) => {
      for (const { field, order } of sortingCriteria) {
        const result = this.dynamicSort(field, order)(a, b);
        if (result !== 0) {
          return result;
        }
      }

      return 0;
    });
  }
  // Map Columns For Enterprise
  generateDynamicColumns(data: any[]): any[] {
    if (data.length === 0) {
      return [];
    }

    const firstItem = data[0];
    return Object.keys(firstItem).map((column: any) => ({
      field: column,
      type: typeof firstItem[column] === 'number' ? 'number' : 'string',
      //title: column.charAt(0).toUpperCase() + column.slice(1)
      title: column,
    }));
  }
  //#endregion

  ngOnInit() {
    // if (this.data?.model?.reportId && (this.reportId == undefined)) {
    //   this.reportId = this.data.model.reportId;
    // }

    // if (this.data?.model?.transactionId && (this.transactionId == undefined)) {
    //   this.transactionId = this.data.model.transactionId;
    // }
    this._datePickerFormat = this._formatService.dateFormat;
    this._reportId = this.reportId;
    this._selectedReportFields = this.selectedReportFields;
    this._showFilter = this.showFilter;
    this._showEmail = this.showEmail;
    this._siteId = this.siteId;

    if (this._selectedReportFields) {
      this._selectedReportDateFields = this.selectedReportFields.filter((x: GridFieldSummary) => x.type == "date");
      this._selectedReportNotDateFields = this.selectedReportFields.filter((x: GridFieldSummary) => x.type != "date");
      this.dateRangeFilterField = this._selectedReportDateFields && this._selectedReportDateFields.length > 0 ? this._selectedReportDateFields[0] : undefined;

      this.filterCriteriaHtml.forEach(element => {
        element.field = this._selectedReportNotDateFields && this._selectedReportNotDateFields.length > 0 ? this._selectedReportNotDateFields[0] : undefined;
        element.logicalOperator = this.operators[0];
      });
    }

    if (this.barcodeModel && this.barcodeModel.LabelSizeID && typeof (this.barcodeModel.LabelSizeID) === "object") {
      if (this.barcodeModel.LabelSize) {
        this.barcodeModel.LabelSizeID = this.barcodeModel.LabelSize.id;
      }
      else {
        this.barcodeModel.LabelSizeID = 0;
      }
    }

    if (this.barcodeModel && !this.barcodeModel.numberOfCopy) {
      this.barcodeModel.numberOfCopy = 1;
    }

    this._windowMode = this.windowMode;
    this._reportObject = this.reportObject;
    this._definitionOnly = this.definitionOnly;
    this._transactionId = this.transactionId;
    this._selectedFields = this.reportObject?.selectedFields;

    // // load stimulsoft js
    // this._lazyLoadingLibraryService
    //     .loadJs('assets/scripts/stimulsoft.reports.pack.js')
    //     .subscribe((x) => {
    //         this.reportFileLoaded = true;
    //         if (this.viewerFileLoaded && this.designerFileLoaded) {
    //             this.initPage();
    //         }
    //     });

    // this._lazyLoadingLibraryService
    //     .loadJs('assets/scripts/stimulsoft.viewer.pack.js')
    //     .subscribe((x) => {
    //         this.viewerFileLoaded = true;
    //         if (this.reportFileLoaded && this.designerFileLoaded) {
    //             this.initPage();
    //         }
    //     });

    // this._lazyLoadingLibraryService
    //     .loadJs('assets/scripts/stimulsoft.designer.pack.js')
    //     .subscribe((x) => {
    //         this.designerFileLoaded = true;
    //         if (this.reportFileLoaded && this.viewerFileLoaded) {
    //             this.initPage();
    //         }
    //     });
  }
  ngAfterViewInit() {
    // load stimulsoft js
    this._lazyLoadingLibraryService.loadJs('assets/scripts/stimulsoft.reports.pack.js').subscribe((x: any) => {
      this.reportFileLoaded = true;

      if (this.viewerFileLoaded && this.designerFileLoaded) {
        this.initPage();
      }
    });

    this._lazyLoadingLibraryService.loadJs('assets/scripts/stimulsoft.viewer.pack.js').subscribe((x: any) => {
      this.viewerFileLoaded = true;

      if (this.reportFileLoaded && this.designerFileLoaded) {
        this.initPage();
      }
    });

    this._lazyLoadingLibraryService.loadJs('assets/scripts/stimulsoft.designer.pack.js').subscribe((x: any) => {
      this.designerFileLoaded = true;
      if (this.reportFileLoaded && this.viewerFileLoaded) {
        this.initPage();
      }
    });

    this.opened = false;
  }

  ngOnChanges(changes: SimpleChanges) {
    if ((changes.reportId && !changes.reportId.firstChange)
      || (changes.reportObject) && !changes.reportObject.firstChange) {
      this._reportId = this.reportId;
      this._reportObject = this.reportObject;
      this._definitionOnly = this.definitionOnly;
      this._windowMode = this.windowMode;
      this.initPage();
    }
  }

  removeEmptyColumnsToSetNullInStimulsoft(data: any[]): any[] {
    data.forEach(item => {
      Object.keys(item).forEach(key => {
        if (!item[key]) {

          //delete item[key];
          item[key] = undefined;
        }
      });
    });

    return data;
  }

  _siteLogoUrl: string = window.location.origin + "/assets/menu/enterprise/asap-logo-2021.jpg";
  _siteName: string = "";
  _siteAddress: string = "";
  _siteAddress1: string = "";
  _siteAddress2: string = "";
  _siteCity: string = "";
  _siteState: string = "";
  _siteZip: string = "";
  _siteCountry: string = "";

  loadSiteLogo(callback: () => void) {
    let siteId = this._siteId || this.siteId || this._reportObject?.ReportObj?.siteId;
    if (!siteId) {
      const loggedInAccountSites = localStorage.getItem('loggedInAccountSites') ?? "";
      if (loggedInAccountSites != "") {
        const site = JSON.parse(loggedInAccountSites)[0];
        if (site && site.siteId) {
          siteId = site.siteId;
        }
      }
    }
    if (siteId) {
      this._multiSiteService.getSiteById(siteId).subscribe({
        next: (site: any) => {
          if (site) {
            this._siteName = site.name;
            this._siteAddress = site.address1 || site.name;
            this._siteAddress1 = site.address1 || "";
            this._siteAddress2 = site.address2 || "";
            this._siteCity = site.city || "";
            this._siteState = site.state || "";
            this._siteZip = site.zip || "";
            this._siteCountry = site.country || "";
            if (site.logo && site.logo.thumbnail) {
              this._siteLogoUrl = EnvironmentLoaderService.envConfig.enterpriseApiLocal + '/' + site.logo.thumbnail;
            } else {
              this._siteLogoUrl = window.location.origin + "/assets/menu/enterprise/asap-logo-2021.jpg";
            }
          } else {
            this._siteName = "";
            this._siteAddress = "";
            this._siteAddress1 = "";
            this._siteAddress2 = "";
            this._siteCity = "";
            this._siteState = "";
            this._siteZip = "";
            this._siteCountry = "";
            this._siteLogoUrl = window.location.origin + "/assets/menu/enterprise/asap-logo-2021.jpg";
          }
          callback();
        },
        error: () => {
          this._siteName = "";
          this._siteAddress = "";
          this._siteAddress1 = "";
          this._siteAddress2 = "";
          this._siteCity = "";
          this._siteState = "";
          this._siteZip = "";
          this._siteCountry = "";
          this._siteLogoUrl = window.location.origin + "/assets/menu/enterprise/asap-logo-2021.jpg";
          callback();
        }
      });
    } else {
      this._siteName = "";
      this._siteAddress = "";
      this._siteAddress1 = "";
      this._siteAddress2 = "";
      this._siteCity = "";
      this._siteState = "";
      this._siteZip = "";
      this._siteCountry = "";
      this._siteLogoUrl = window.location.origin + "/assets/menu/enterprise/asap-logo-2021.jpg";
      callback();
    }
  }

  initPage() {
    this.loadSiteLogo(() => {
      this.initStimulsoft();
      if (!this._windowMode) {
        this.options.appearance.scrollbarsMode = false;
        this.options.toolbar.visible = false;
        this.options.toolbar.zoom = 0.4;
        this.options.appearance.defaultUnit = Stimulsoft.Report.StiReportUnitType.Inches // Inches
      }
      else {
        this.options.displayMode = Stimulsoft.Viewer.StiToolbarDisplayMode.Simple;
        this.options.appearance.defaultUnit = Stimulsoft.Report.StiReportUnitType.Inches // Inches
      }

      this.viewer = new Stimulsoft.Viewer.StiViewer(this.options, 'StiViewer', false);
      this.opened = false;

      if (!this.barcodeModel) {
        this.dataSet = new Stimulsoft.System.Data.DataSet('DataSet');

        if (!this._reportId && !this._windowMode && this._reportObject) {
          this._reportObject.ReportObj.addLogo = this._reportObject.ReportObj.addLogo == "Yes" ? true : false;
          this._reportObject.ReportObj.addAddress = this._reportObject.ReportObj.addAddress == "Yes" ? true : false;

          if (this._reportObject.ReportObj.dataSource != undefined && this._reportObject.ReportObj.dataSource.includes("GetReportbyDataSourceName")) {
            if (!this._reportObject.ReportObj.selectedFields) {
              setTimeout(() => {
                this.createReportPreview(null);
              }, 200);
            }
            else {
              this._reportService.PreviewReportData(this._reportObject.ReportObj).subscribe((response: any) => {
                // response.forEach((element: any) => {
                //   element.categoryImage = "http://localhost:11567/Resources/AccountId_1/thumbnails/Abir0.png"
                // });
                setTimeout(() => {
                  this.dataSet = new Stimulsoft.System.Data.DataSet('DataSet');
                  //response = this.removeEmptyColumnsToSetNullInStimulsoft(response);
                  this.createReportPreview(response);
                }, 200);
              });
            }
          }
          else {
            setTimeout(() => {
              this.createReportPreview(null);
            }, 200);
          }
        }
        else {
          this._reportService.ReportById(this._reportId).subscribe((x: any) => {
            this.dbReport = x;
            this.stimulsoftReport.loadEncryptedReport(this.dbReport.definition, environment.reportsKey);
            //"bXJ4+ODXG22PZmDv3f1DauAAaIUcU6M72O3ry1kxcHSlXXsqF2WS4hHXpbIa4VcKNEvkEWgqpes8THd7gro194bcF5kKvtfFkr4F+DozKiNwuWXGaED0UvszU849MAK9nNOzWUSjAJ182iyKR7+5lREQMrzWhmxO7U5x7/BGHKQmMF5BjIs5cTz4KrIhwQRiLr0NFSORpbOwE0Nm8Bu+1LuDUj6+hainzUc43h3coaWaNxi77MhZV4SRK3M+ytJirRpslFo2QX3fnFACHWgZrD3eVpVtA3lVUdJ6nr/VNT3EtLM+WaOHXPZpIgKSHmK2Czc68PPjlUZUNh5TcJpPaxCLnUFPq+Y7fJteGy1w4rcjhLE59GsUozppqXFn4xmHYEZMREc2w0pI7l7LHvFnT17Uc27PAMpBAMMWuUeaDD/lY+BZncIsGHZ+b8rKyGXSNEmWamLN9yvokeepSK+NVOUSYKVole7aapW0aytxWc/4kDsgiweW+/v1LRHp/tiAlF2NPks3ZGCYuppJ5k4Z98iti+oJyw3CNJ0kA+Strrxz9rj6tg8jHwxzJjiZCKySIZV+oKp5cVBMZKAzGgArqKxv0dxh5BUranatZ574Zh4Ckxkq9lf0RtzSgtV6h56lWaPCslvrtAR5HmhfRxUPXZ5rl9chvwuaEZlEZvuZDBPlDJ17y4Y+SSyQIps4FEjPrC/QskHfEs+JFFydAKjXyoZMkUUHsczh1HkSNi9e0Xrmwd8RU6BQrxwbxDder/9F8UaKCM+Q8lqJ7OzMyTvhPAYGp6vE+jWDhoxMt/2dZCTuNc9ciav6rW6jNPy9Po3cT1Okjg5NMhTXiFy9X70fU+FWWO+aeNQg6M3DNdsiUaM2293ZAjl1zQ/m1Jfjn4NLhYsQL6KUww6+kITRCqLY9EDS9KCsbT6X6FW5n+LfTiZr2qt8Wgixm2UWseVs1fOBhe3ww1z/4FYDQvza43SyhB2AJz2GfAq58aQBxfQdmKmeprG0DD1xZWG9jUgE/O2NzOOKWy1IOBXJtEiIvZleODXUfNRIvzEyCG93NvyYdNQBlP5u2l34XQj020/YpxYMryjV7iKC+iaNOj+8uH7++qx/Lo8/Y3SpufQKOWoimFm2bNz90sIidCBHpRCV8SAPI3gPXrcqZG6q+2osHq7JM+n60/YV5ZApxGIx7u080kzOklT00bRnetETJdPM1t70X85mbBz3RxDKK/L0yXEWh0V9WSIeaJirY98YhGENOPqwE8/PyFFzes9Vi5XzViLKrVDxf8RS232Awhqro0UGI6KMkTGyPNQfpbPfEP2ckM+HTC2qzKUOZ009AUEPUo9oHBj5jwT8sf72uJN80mrGC5TFxVTNLePmDqANJqaCgAw43cF64EFVcDTWz/U/GXCIr48ZysSfaQt+ReqdGema/6AAek379nSJb5h/J7Nu6iqsvrYrMk0A36p3yMagqw88HGQFjudbqlJNmedpWfzWMkd7AmdoGk7OE4StG9zNQV2XZbWPUIBIdq1cgPLYDNXYZMclzWiKgDkkvuv7pqen0daMWkLSGWyaYll8FRn2fPMmlJNzmkkKMUfKOo20VQ8X3YMtvQAd3J1K9y7GnCYKdFGcKbtX6RCWDGlQSSjObjEuEuc3F9wCpA98gVqM4wsFCewpnCcUIBwST9JGkLYC5Lom6+/1A2AHFoDTkDIy1gS0W4dYMC/GdGYZwr9L287gbNqC1Lc2QQQ0OgZw+LRru+qp0oQ1NdwWGxmHcx04",

            if (x.dataSource != undefined && x.dataSource.toLocaleLowerCase().includes("getreportbydatasourcename")) {
              if (x.dataSource.includes("Report_")) {
                this._reportService.GetReportData(this._reportId, this.transactionId, this._siteId).subscribe((response: any) => {
                  response = this.removeEmptyColumnsToSetNullInStimulsoft(response);
                  
                  //TODO:: Refact it from Backend
                  if (x.dataSource.includes("Report_GetAllInventories") && x.selectedFields.includes("availability")) {
                    this._zeroQuantitySettingsService.getZeroQuantitySetting().subscribe((data) => {
                      if (data?.enabled == false) {
                        const filteredItems = (response as any[]).filter(item => item.availability > 0);
                        this.openReport(filteredItems);
                      } else {
                        this.openReport(response as Array<any>);
                      }
                    });
                  } else {
                    this.openReport(response as Array<any>);
                  }
                });
              }
              else {
                this._reportService.GetReportbyDataSourceName(this.dbReport.dataSource).subscribe((response: any) => {
                  // var MappedDynamicGridFields = this.generateDynamicColumns(response);

                  // this._selectedReportDateFields = MappedDynamicGridFields.filter((x: GridFieldSummary) => x.type == "date");
                  // this._selectedReportNotDateFields = MappedDynamicGridFields.filter((x: GridFieldSummary) => x.type != "date");
                  // this.dateRangeFilterField = this._selectedReportDateFields && this._selectedReportDateFields.length > 0 ? this._selectedReportDateFields[0] : undefined;
                  // this.filterCriteriaHtml.forEach(element => {
                  //   element.field = this._selectedReportNotDateFields && this._selectedReportNotDateFields.length > 0 ? this._selectedReportNotDateFields[0] : undefined;
                  //   element.logicalOperator = this.operators[0];
                  // });
                  // this._showFilter = true;
                  response = this.removeEmptyColumnsToSetNullInStimulsoft(response);
                  this.openReport(response as Array<any>);
                });
              }
            }
            else {
              if (x.dataSource != undefined && this.dbReport.dataSource == '/Reports/ForecastMonthToMonth') {
                this.opened = true;
              }
              else if (this.dbReport.isForecast) {
                let config: any = {};
                if (this.dbReport.forecastConfig) {
                  if (typeof this.dbReport.forecastConfig === 'string') {
                    try {
                      config = JSON.parse(this.dbReport.forecastConfig);
                    } catch (e) {
                      config = {};
                    }
                  } else {
                    config = this.dbReport.forecastConfig;
                  }
                }
                this._reportService.ProcessForecast(config).subscribe({
                  next: (response: any) => {
                    response = this.removeEmptyColumnsToSetNullInStimulsoft(response);
                    this.openReport(response as Array<any>);
                  },
                  error: (err: any) => {
                    console.error('Error processing forecast in viewer:', err);
                  }
                });
              }
              else {
                this._reportService.GetReportData_GET(this.dbReport.dataSource).subscribe(
                  (response: any) => {
                    response = this.removeEmptyColumnsToSetNullInStimulsoft(response);
                    this.openReport(response as Array<any>);
                  }
                );
              }
            }
          });
        }
      }
      else {
        this.dataSet = new Stimulsoft.System.Data.DataSet('DataSet');

        if (this.isCatalog) {
          if (!this._reportId && !this._windowMode && this._reportObject) {
            this._reportObject.ReportObj.addLogo = this._reportObject.ReportObj.addLogo == "Yes" ? true : false;
            this._reportObject.ReportObj.addAddress = this._reportObject.ReportObj.addAddress == "Yes" ? true : false;

            if (this._reportObject.ReportObj.dataSource != undefined &&
              this._reportObject.ReportObj.dataSource.includes("GetReportbyDataSourceName")) {

              if (this._reportObject.ReportObj.selectedFields) {
                this._reportObject.ReportObj.selectedFields = this.GetDistinctSelectFieldsString(this._reportObject.ReportObj.selectedFields);
                this._reportService.PreviewReportData(this._reportObject.ReportObj).subscribe((response: any) => {
                  setTimeout(() => {
                    //response = this.removeEmptyColumnsToSetNullInStimulsoft(response);
                    this.createBarcodeCatalogPreview(response);
                  }, 200);
                });
              }
            }
          }
        }
        else {
          if (!this.previewMode) {
            if (!this._reportId && !this._windowMode && this._reportObject) {
              this._reportObject.ReportObj.addLogo = this._reportObject.ReportObj.addLogo == "Yes" ? true : false;
              this._reportObject.ReportObj.addAddress = this._reportObject.ReportObj.addAddress == "Yes" ? true : false;

              if (this._reportObject.ReportObj.dataSource != undefined &&
                this._reportObject.ReportObj.dataSource.includes("GetReportbyDataSourceName")) {
                // Barcode Label Upsert Preview

                if (this._reportObject.ReportObj.selectedFields) {
                  this._reportObject.ReportObj.selectedFields = this.GetDistinctSelectFieldsString(this._reportObject.ReportObj.selectedFields);
                  this._reportService.PreviewReportData(this._reportObject.ReportObj).subscribe(
                    (response: any) => {
                      setTimeout(() => {
                        this.barcodeModel.Row = 1;
                        this.barcodeModel.Column = 1;
                        // this.openReportBarcodeLabelWithReportDefinition(this._reportObject, response);
                        if (this._reportObject.ReportObj.definition) {
                          //response = this.removeEmptyColumnsToSetNullInStimulsoft(response);
                          this.openReportBarcodeLabelWithReportDefinitionForEditBarcode(this._reportObject, response);
                          //  this.createReportbarcodePreviewWithReportDefinition(response,
                          //       this.barcodeModel.LabelSizeID,
                          //       this.barcodeModel.Row,
                          //       this.barcodeModel.Column,
                          //       null,
                          //       this.barcodeModel.LabelSize,
                          //       this.barcodeModel.isQr ? this.barcodeModel.isQr : false);
                        }
                        else {
                          //response = this.removeEmptyColumnsToSetNullInStimulsoft(response);
                          this.createReportbarcodePreview_3(response,
                            this.barcodeModel.LabelSizeID,
                            this.barcodeModel.Row,
                            this.barcodeModel.Column,
                            null,
                            this.barcodeModel.LabelSize,
                            this.barcodeModel.isQr ? this.barcodeModel.isQr : false);
                        }

                      }, 200);
                    });
                }
              }
            }
            else {
              this._reportObject.ReportObj.addLogo = this._reportObject.ReportObj.addLogo == "Yes" ? true : false;
              this._reportObject.ReportObj.addAddress = this._reportObject.ReportObj.addAddress == "Yes" ? true : false;

              if (this._reportObject.ReportObj.selectedFields) {
                this._reportObject.ReportObj.selectedFields = this.GetDistinctSelectFieldsString(this._reportObject.ReportObj.selectedFields);
                this._reportService.PreviewReportData(this._reportObject.ReportObj).subscribe((response: any) => {
                  response = this.removeEmptyColumnsToSetNullInStimulsoft(response);

                  setTimeout(() => {
                    if (this._reportObject.ReportObj.definition) // Custom Labels
                    {

                      this.openReportBarcodeLabelWithReportDefinition(this._reportObject, response);
                    }
                    else {
                      if (this._reportObject.ReportObj.customLabel == false
                        && this.reportObject.ReportObj.name != 'Asset with Name' && this.reportObject.ReportObj.name != 'Asset with Model #') {
                        response.forEach((element: any) => {
                          let model = { BarcodeNumber: '' };
                          model.BarcodeNumber = element.BarcodeNumber ?? element[this._reportObject.ReportObj.primaryField];
                          if (!this.barcodeModel.BarcodeValues)
                            this.barcodeModel.BarcodeValues = [];
                          this.barcodeModel.BarcodeValues.push(model);

                        });

                        if (this.barcodeModel.Row > 1 || this.barcodeModel.Column > 1) {
                          response = this.SkipRowsAndColumns(response, this.barcodeModel.Row, this.barcodeModel.Column, this.barcodeModel.LabelSize.columns)
                        }

                        this.Barcode_PrePrintBarcodes(this.barcodeModel.BarcodeValues,
                          this.barcodeModel.LabelSizeID,
                          this.barcodeModel.Row,
                          this.barcodeModel.Column,
                          null,
                          this.barcodeModel.LabelSize,
                          this.barcodeModel.numberOfCopy);
                      }
                      else {
                        if (this.barcodeModel.Row > 1 || this.barcodeModel.Column > 1) {
                          response = this.SkipRowsAndColumns(response, this.barcodeModel.Row, this.barcodeModel.Column, this.barcodeModel.LabelSize.columns)
                        }

                        this._labelsService.getDefaultDefinition(this.barcodeModel.LabelPresetId, this.barcodeModel.LabelSizeID).subscribe((def: any) => {
                          if (def && def.defaultDefinition) {
                            this.reportObject.ReportObj.definition = def.defaultDefinition?.definition;
                            this.openReportBarcodeLabelWithReportDefinition(this._reportObject, response);
                          }
                        });
                      }
                    }
                  }, 200);
                });
              }
              //Old
              // if(this._reportObject && this._reportObject.ReportObj && this._reportObject.ReportObj.definition) // Custom Labels Or // Asset With Name // Asset With Model #
              //  {
              //   this.openReportBarcodeLabelWithReportDefinition(this._reportObject);
              //  else // System Labels
              //  {
              //   this.Barcode_PrePrintBarcodes(this.barcodeModel.BarcodeValues,
              //     this.barcodeModel.LabelSizeID,
              //     this.barcodeModel.Row,
              //     this.barcodeModel.Column,
              //     null,
              //     this.barcodeModel.LabelSize,
              //     this.barcodeModel.numberOfCopy);
            }
          }
          else {
            if (this.barcodeModel.customLabelPreset == true) // For Print Label In Receive Transaction // Pre Printed Custom labels
            {
              const presetId = (this.barcodeModel.LabelPresetId && typeof this.barcodeModel.LabelPresetId === 'object')
                ? (this.barcodeModel.LabelPresetId.id ?? this.barcodeModel.LabelPresetId.Id)
                : this.barcodeModel.LabelPresetId;

              if (presetId && presetId !== 'undefined' && !isNaN(Number(presetId))) {
                this._labelsService.getLabelPresetById(Number(presetId)).subscribe((labelPreset: LabelPreset) => {
                  if (labelPreset && labelPreset.reportDefinition) {
                    if (!this.barcodeModel.transactionId) {
                      this.openReportBarcodeLabelWithReportDefinitionWithoutReportObject(this.barcodeModel.BarcodeValues as Array<any>, labelPreset.reportDefinition);
                    }
                    else {
                      this._reportService.GetReportDataForBarcodeLabelDesigner(Number(presetId),
                        this.barcodeModel.transactionId ?? null,
                        this.barcodeModel?.tableName).subscribe((response: any) => {
                          this.openReportBarcodeLabelWithReportDefinitionWithoutReportObject(response as Array<any>, labelPreset.reportDefinition);
                        });
                    }
                  }
                });
              }
            }
            else // for pre print custom/non custom BARCODES
            {
              this.Barcode_PrePrintBarcodes(this.barcodeModel.BarcodeValues,
                this.barcodeModel.LabelSizeID,
                this.barcodeModel.Row,
                this.barcodeModel.Column,
                null,
                this.barcodeModel.LabelSize,
                this.barcodeModel.numberOfCopy);
            }
          }
        }
      }
    });
  }

  HandleAveryLabelSizeForMultipleCopies(data: any, noOfCopies: number) {
    return Array.from({ length: noOfCopies }, () => [...data]).flat();
  }

  private createReportPreview(response: any) {
    this.dataSet = new Stimulsoft.System.Data.DataSet('DataSet');
    this.stimulsoftReport.reportUnit = Stimulsoft.Report.StiReportUnitType.Inches // Inches
    let that = this;
    var xobject = {};
    var allFields = that._reportObject.ReportObj.selectedFields.split(',');

    if (response && response.length > 0) {
      response.forEach((element: any) => {
        // element.categoryImage = "http://localhost:11567/Resources/AccountId_1/thumbnails/Abir0.png"
        //element.categoryImage = EnvironmentLoaderService.envConfig.enterpriseApiLocal+'/' + element.categoryImage;
      });
      // limit to 20 rows displayed on the page.
      response = response.slice(0, 20);

      var getSelectedFields = Array.prototype.map.call((response as Array<any>), function (item: any) {
        xobject = {};

        for (let field of allFields) {

          (xobject as any)[field] = item[field];
        }
        return xobject;
      });
      //     var getSelectedFields:any[] = [];
      // response.forEach((element:any) => {
      //   if (allFields){
      //     xobject = {};
      //     for (let field of allFields) {

      //         (xobject as any)[field] = element[field];

      //     }
      //     getSelectedFields.push(xobject);
      //   }
      // });
      this.dataSet.readJson(getSelectedFields);
    }
    else if (response != null) {
      var modelObject = {};
      var stringObject = "{";
      allFields.forEach((element: string) => {
        stringObject += "\"" + element + "\":\"\",";
      });
      stringObject = stringObject.substring(0, stringObject.length - 1);
      stringObject += "}";
      modelObject = JSON.parse(stringObject);
      this.dataSet.readJson(modelObject);
    }

    this.stimulsoftReport.dictionary.databases.clear();

    if (this._reportObject.ReportObj.addAddress || this._reportObject.ReportObj.addLogo) {
      var addressLogoData = [
        {
          SiteName: this._siteName || "",
          SiteAddress: this._siteAddress || this._siteName || "",
          Address1: this._siteAddress1,
          Address2: this._siteAddress2,
          City: this._siteCity,
          State: this._siteState,
          Zip: this._siteZip,
          Country: this._siteCountry,
          Logo: this._siteLogoUrl
        }
      ];
      var addressLogoDataSet = new Stimulsoft.System.Data.DataSet("AddressLogoDataSet");
      addressLogoDataSet.readJson({ AddressLogoDataSet: addressLogoData });
      if (addressLogoDataSet.tables.list && addressLogoDataSet.tables.list[0]) {
        addressLogoDataSet.tables.list[0].tableName = "AddressLogoDataSet";
      }
      this.stimulsoftReport.regData("AddressLogoDataSet", "AddressLogoDataSet", addressLogoDataSet);
    }

    this.stimulsoftReport.regData(this.dataSet.dataSetName, '', this.dataSet);

    // Create Page
    var page = this.stimulsoftReport.pages.getByIndex(0);
    page._pageWidth = 8.5;
    page._pageHeight = 11;
    // page.width = 8.5;
    this._reportObject.ReportObj.orientation = this._reportObject.ReportObj.orientation || "Portrait";

    if (this._reportObject.ReportObj.orientation == "Portrait") {
      page.orientation = Stimulsoft.Report.Components.StiPageOrientation.Portrait;
    }
    else {
      page.orientation = Stimulsoft.Report.Components.StiPageOrientation.Landscape;
    }

    // Create Title Band
    var TitleBandHeight = (this._reportObject.ReportObj.addLogo || this._reportObject.ReportObj.addAddress) ? 0.55 : 0.3;

    var TitleBand = new Stimulsoft.Report.Components.StiReportTitleBand();
    TitleBand.name = "TitleBand";
    TitleBand.height = TitleBandHeight;
    page.components.add(TitleBand);

    if (this._reportObject.ReportObj.addLogo) {
      var LogoImage = new Stimulsoft.Report.Components.StiImage(new Stimulsoft.Base.Drawing.RectangleD(0, 0, 0.8, 0.52));
      LogoImage.horAlignment = Stimulsoft.Base.Drawing.StiHorAlignment.Left;
      LogoImage.enabled = true;
      LogoImage.stretch = true;
      LogoImage.name = "TitleLogo";
      LogoImage.imageURL = this._siteLogoUrl;
      LogoImage.printOn = Stimulsoft.Report.Components.StiPrintOnType.OnlyFirstPage;
      TitleBand.setHeight(TitleBandHeight)
      TitleBand.components.add(LogoImage);
    }

    if (this._reportObject.ReportObj.addAddress) {
      var multiLineAddress = (this._siteName ? "{AddressLogoDataSet.SiteName}\n" : "") +
        "{AddressLogoDataSet.Address1}\n" +
        "{AddressLogoDataSet.Address2}\n" +
        "{AddressLogoDataSet.City}, {AddressLogoDataSet.State} {AddressLogoDataSet.Zip}\n" +
        "{AddressLogoDataSet.Country}";
      var addressText = new Stimulsoft.Report.Components.StiText(new Stimulsoft.Base.Drawing.RectangleD(this._reportObject.ReportObj.orientation == "Portrait" ? 4.5 : 7.0, 0, 3.5, 0.55));
      addressText.text = multiLineAddress;
      addressText.horAlignment = Stimulsoft.Base.Drawing.StiTextHorAlignment.Right;
      addressText.vertAlignment = Stimulsoft.Base.Drawing.StiVertAlignment.Top;
      addressText.name = "TitleAddress";
      addressText.font = new Stimulsoft.System.Drawing.Font("Arial", 8, Stimulsoft.System.Drawing.FontStyle.Regular);
      addressText.canGrow = true;
      TitleBand.components.add(addressText);
    }

    var TitleWidth = page.Width;
    var StartTitle = 0;
    var StartHeightTitle = 0;

    if (this._reportObject.ReportObj.addAddress || this._reportObject.ReportObj.addLogo) {
      StartHeightTitle = 0.55;

      if (this._reportObject.ReportObj.addLogo) {
        TitleWidth = TitleWidth - 0.8;
        StartTitle = 0.8;
      }

      if (this._reportObject.ReportObj.addAddress)
        TitleWidth = TitleWidth - 3.7;
    }
    var titleText = new Stimulsoft.Report.Components.StiText();

    titleText.clientRectangle = new Stimulsoft.Base.Drawing.RectangleD(0, this._reportObject.ReportObj.addAddress || this._reportObject.ReportObj.addLogo ? 0.55 : 0, page.width, 0.2);
    titleText.text = (this._reportObject.ReportObj.name as string);
    titleText.horAlignment = Stimulsoft.Base.Drawing.StiTextHorAlignment.Center;
    titleText.name = "HeaderText";
    titleText.font = new Stimulsoft.System.Drawing.Font("Arial", 15, Stimulsoft.System.Drawing.FontStyle.Bold);

    TitleBand.components.add(titleText);

    var headerBand = new Stimulsoft.Report.Components.StiHeaderBand();
    var GroupHeaderBand = new Stimulsoft.Report.Components.StiGroupHeaderBand(new Stimulsoft.Base.Drawing.RectangleD(0, 0, 3.03, 0.27));
    var groupHeaders = [];
    if (this._reportObject.ReportObj.groupBy) {
      groupHeaders = this._reportObject.selectedFields.filter((x: any) => x.gpSelected == true);
      if (groupHeaders.length == 0) {
        groupHeaders = this._reportObject.selectedFields.filter((x: any) => x.field == (this._reportObject.ReportObj.groupBy));
      }

      var columnHeight = Stimulsoft.Base.StiAlignValue.alignToMinGrid(0.27 / groupHeaders.length, 0.1, true);
      // var columnHeight = 0.71 / groupHeaders, 0.1, true);
      var posY = 0;
      GroupHeaderBand.clientRectangle = new Stimulsoft.Base.Drawing.RectangleD(0, posY, 3.03, columnHeight);
      //GroupHeaderBand.name = "GroupHeaderBand"  + this._reportObject.ReportObj.groupBy;
      GroupHeaderBand.name = "GroupHeaderBand";
      GroupHeaderBand.height = 0.2;
      var groupbylabel = this._reportObject.ReportObj.groupBy.includes(".") || this.hasWhiteSpace(this._reportObject.ReportObj.groupBy) ? "[" + this._reportObject.ReportObj.groupBy + "]" : this._reportObject.ReportObj.groupBy;
      GroupHeaderBand.condition = "{root." + groupbylabel + "}";
      var dataText1 = new Stimulsoft.Report.Components.StiText();
      dataText1.canGrow = true;
      dataText1.clientRectangle = new Stimulsoft.Base.Drawing.RectangleD(0.2, posY, 3.03, columnHeight);
      var dataText1label = this._reportObject.ReportObj.groupBy.includes(".") || this.hasWhiteSpace(this._reportObject.ReportObj.groupBy) ? "[" + this._reportObject.ReportObj.groupBy + "]" : this._reportObject.ReportObj.groupBy;
      var GroupByLabelText = this._reportObject.selectedFields.find((x: any) => x.field == this._reportObject.ReportObj.groupBy).title;
      dataText1.text = GroupByLabelText + ":{root." + dataText1label + "}";
      dataText1.name = "GroupHeaderBy" + "_" + dataText1label;
      // dataText1.border.side = Stimulsoft.Base.Drawing.StiBorderSides.Bottom;
      dataText1.font = new Stimulsoft.System.Drawing.Font("Arial", 9, Stimulsoft.System.Drawing.FontStyle.Italic);
      page.components.add(GroupHeaderBand);
      GroupHeaderBand.components.add(dataText1);
      posY += columnHeight;
      var GroupIndex = 1;
      groupHeaders.forEach((element: any) => {


        if (element.field != this._reportObject.ReportObj.groupBy) {
          var dataText1 = new Stimulsoft.Report.Components.StiText();
          dataText1.canGrow = true;
          dataText1.clientRectangle = new Stimulsoft.Base.Drawing.RectangleD(0.2, posY, 3.03, columnHeight);
          var dataText1label = element.field.includes(".") || this.hasWhiteSpace(element.field) ? "[" + element.field + "]" : element.field;
          var GroupByLabelText = this._reportObject.selectedFields.find((x: any) => x.field == element.field).title;
          dataText1.text = GroupByLabelText + ":{root." + dataText1label + "}";
          dataText1.name = "GroupHeader" + GroupIndex;
          dataText1.font = new Stimulsoft.System.Drawing.Font("Arial", 9, Stimulsoft.System.Drawing.FontStyle.Italic);
          // dataText1.border.side = Stimulsoft.Base.Drawing.StiBorderSides.Bottom;
          // GroupHeaderBand.condition = "{root." + dataText1label + "}"
          //page.components.add(GroupHeaderBand);
          GroupHeaderBand.components.add(dataText1);
          posY += columnHeight;
          GroupIndex++
        }
      });



    }
    else {
      //Create HeaderBand
      headerBand.height = 0.2;
      headerBand.name = "HeaderBand";
      page.components.add(headerBand);
    }

    // Create Databand
    var dataBand = new Stimulsoft.Report.Components.StiDataBand();
    dataBand.dataSourceName = "root";
    dataBand.height = 0.2;
    dataBand.name = "DataBand";
    page.components.add(dataBand);

    var pos = 0;
    var dataBandAdded = false;
    if (this.dataSet.tables.list && this.dataSet.tables.list[0]) {
      if (this._reportObject.ReportObj.groupBy) // - 1 to remove the group by column from data
      {
        if (groupHeaders.length == 0)
          var columnWidth = Stimulsoft.Base.StiAlignValue.alignToMinGrid(page.width / (this.dataSet.tables.list[0].columns.count - 1), page.width / (this.dataSet.tables.list[0].columns.count - 1), true);
        else {

          var groupHeadersWithoutGroupBy = groupHeaders.filter((x: any) => x.field != this._reportObject.ReportObj.groupBy);
          var test = this.dataSet.tables.list[0].columns.count - groupHeadersWithoutGroupBy.length - 1;
          //var columnWidth = Stimulsoft.Base.StiAlignValue.alignToMinGrid(page.width / (this.dataSet.tables.list[0].columns.count - groupHeadersWithoutGroupBy.length - 1), 0.1, true);
          var columnWidth = Stimulsoft.Base.StiAlignValue.alignToMinGrid(page.width / (this.dataSet.tables.list[0].columns.count - groupHeadersWithoutGroupBy.length - 1), page.width / (this.dataSet.tables.list[0].columns.count - groupHeadersWithoutGroupBy.length - 1), true);
        }

      }
      else {
        var columnWidth = Stimulsoft.Base.StiAlignValue.alignToMinGrid(page.width / this.dataSet.tables.list[0].columns.count, page.width / this.dataSet.tables.list[0].columns.count, true);
      }


      var nameIndex = 1;
      for (var index in this.dataSet.tables.list[0].columns.list) {
        var dataColumn = this.dataSet.tables.list[0].columns.list[index];

        //Create text on header
        //if (!this._reportObject.ReportObj.groupBy) {
        if (this._reportObject.ReportObj.groupBy != dataColumn.columnName
          && groupHeaders.filter((x: any) => x.field == dataColumn.columnName).length == 0) {

          var headerText = new Stimulsoft.Report.Components.StiText();
          if (this._reportObject.ReportObj.groupBy)
            headerText.clientRectangle = new Stimulsoft.Base.Drawing.RectangleD(pos, posY, columnWidth, 0.2);
          else
            headerText.clientRectangle = new Stimulsoft.Base.Drawing.RectangleD(pos, 0, columnWidth, 0.2);

          if (dataColumn.columnName == dataColumn.caption) {
            headerText.text = this._reportObject.selectedFields.find((x: any) => x.field == dataColumn.caption).title;
          }
          else {
            headerText.text = dataColumn.caption;
          }

          headerText.name = "HeaderText" + nameIndex.toString();
          headerText.font = new Stimulsoft.System.Drawing.Font("Arial", 9, Stimulsoft.System.Drawing.FontStyle.Bold);
          headerText.horAlignment = Stimulsoft.Base.Drawing.StiTextHorAlignment.Center;
          headerText.border.side = Stimulsoft.Base.Drawing.StiBorderSides.Bottom;

          //headerBand.components.add(headerText);
          if (this._reportObject.ReportObj.groupBy)
            GroupHeaderBand.components.add(headerText);
          else
            headerBand.components.add(headerText);


          ////////Bakr/////////////////


          if (this.reportObject.selectedFields.find((x: any) => x.field == dataColumn.columnName && x.type == 'image')) {

            var ImageColumn = new Stimulsoft.Report.Components.StiImage(new Stimulsoft.Base.Drawing.RectangleD(pos, 0, columnWidth, 0.2));
            ImageColumn.horAlignment = Stimulsoft.Base.Drawing.StiHorAlignment.Center;
            let newImg = new Stimulsoft.System.Drawing.Image();

            var dataTextlabel = dataColumn.columnName.includes(".") || this.hasWhiteSpace(dataColumn.columnName) ? "[" + dataColumn.columnName + "]" : dataColumn.columnName;
            ImageColumn.imageURL = "{root." + dataTextlabel + "}";

            ImageColumn.enabled = true;
            ImageColumn.stretch = true;

            ImageColumn.name = "DataImage" + nameIndex.toString();

            dataBand.components.add(ImageColumn);
            pos = pos + columnWidth;
          }
          else {
            //Create text on Data Band
            var dataText = new Stimulsoft.Report.Components.StiText();
            dataText.clientRectangle = new Stimulsoft.Base.Drawing.RectangleD(pos, 0, columnWidth, 0.2);
            var dataTextlabel = dataColumn.columnName.includes(".") || this.hasWhiteSpace(dataColumn.columnName) ? "[" + dataColumn.columnName + "]" : dataColumn.columnName;
            dataText.text = "{root." + dataTextlabel + "}";
            dataText.name = "DataText" + nameIndex.toString();
            dataText.horAlignment = Stimulsoft.Base.Drawing.StiTextHorAlignment.Center;
            //dataText.border.side = Stimulsoft.Base.Drawing.StiBorderSides.Bottom;
            dataBand.components.add(dataText);
            pos = pos + columnWidth;
          }


          // posY += columnHeight;
          nameIndex++;
          dataBandAdded = true;
        }

      }
    }
    if (!dataBandAdded)
      dataBand.height = 0;
    //Create Group FooterBand
    var footerBand = new Stimulsoft.Report.Components.StiGroupFooterBand();

    if (this._reportObject.ReportObj.groupBy) {
      footerBand.height = 0.2;
      footerBand.name = "FooterBand";
      page.components.add(footerBand);
    }

    //Create text on footer
    var footerText = new Stimulsoft.Report.Components.StiText();
    footerText.clientRectangle = new Stimulsoft.Base.Drawing.RectangleD(0, 0, page.width, 0.2);
    footerText.text = "Count - {Count()}";
    footerText.horAlignment = Stimulsoft.Base.Drawing.StiTextHorAlignment.Center;
    footerText.name = "FooterText";
    //footerText.brush = new Stimulsoft.Base.Drawing.StiSolidBrush(Stimulsoft.System.Drawing.Color.lightGreen);
    footerBand.components.add(footerText);
    this.stimulsoftReport.dictionary.synchronize();

    this.viewer.report = this.stimulsoftReport;

    if (this._definitionOnly) {
      this.returnDefinition.emit(this.stimulsoftReport.saveEncryptedReportToString(environment.reportsKey));
    }

    else {
      this.viewer.renderHtml('viewer');
    }
  }


  private createBarcodeCatalogPreview(response: any) {
    this.stimulsoftReport.reportUnit = Stimulsoft.Report.StiReportUnitType.Inches // Inches
    let that = this;
    var xobject = {};
    let allFields: any[] = [];
    that._reportObject.selectedFields.forEach((element: any) => {
      if (!element.title.includes("(barcode image)"))
        allFields.push(element.field);
    });
    let allbarcodeFields: any[] = [];
    that._reportObject.selectedFields.forEach((element: any) => {
      if (element.title.includes("(barcode image)"))
        allbarcodeFields.push(element.field + "(barcode image)");
    });
    if (response && response.length > 0) {
      // limit to 20 rows displayed on the page.
      response = response.slice(0, 20);
      var getSelectedFields = Array.prototype.map.call((response as Array<any>), function (item: any) {
        xobject = {};
        if (allFields) {
          for (let field of allFields) {
            (xobject as any)[field] = item[field];
          }
        }
        if (allbarcodeFields) {
          for (let field of allbarcodeFields) {
            (xobject as any)[field] = item[field.replace("(barcode image)", "")];
          }
        }
        return xobject;
      });
      this.dataSet.readJson(getSelectedFields);
    }
    else if (response != null) {
      var modelObject = {};
      var stringObject = "{";
      allFields.forEach((element: string) => {
        stringObject += "\"" + element + "\":\"\",";
      });
      stringObject = stringObject.substring(0, stringObject.length - 1);
      stringObject += "}";
      modelObject = JSON.parse(stringObject);
      this.dataSet.readJson(modelObject);
    }

    if (this._reportObject.ReportObj.addAddress || this._reportObject.ReportObj.addLogo) {
      var addressLogoData = [
        {
          SiteName: this._siteName || "",
          SiteAddress: this._siteAddress || this._siteName || "",
          Address1: this._siteAddress1,
          Address2: this._siteAddress2,
          City: this._siteCity,
          State: this._siteState,
          Zip: this._siteZip,
          Country: this._siteCountry,
          Logo: this._siteLogoUrl
        }
      ];
      var addressLogoDataSet = new Stimulsoft.System.Data.DataSet("AddressLogoDataSet");
      addressLogoDataSet.readJson({ AddressLogoDataSet: addressLogoData });
      if (addressLogoDataSet.tables.list && addressLogoDataSet.tables.list[0]) {
        addressLogoDataSet.tables.list[0].tableName = "AddressLogoDataSet";
      }
      this.stimulsoftReport.regData("AddressLogoDataSet", "AddressLogoDataSet", addressLogoDataSet);
    }
    this.stimulsoftReport.regData(this.dataSet.dataSetName, '', this.dataSet);

    // Create Page
    var page = this.stimulsoftReport.pages.getByIndex(0);
    page._pageWidth = 8.5;
    page._pageHeight = 11;
    this._reportObject.ReportObj.orientation = this._reportObject.ReportObj.orientation || "Portrait";
    if (this._reportObject.ReportObj.orientation == "Portrait") {
      page.orientation = Stimulsoft.Report.Components.StiPageOrientation.Portrait;
    }

    else {
      page.orientation = Stimulsoft.Report.Components.StiPageOrientation.Landscape;
    }

    // Create Title Band
    var TitleBandHeight = (this._reportObject.ReportObj.addLogo || this._reportObject.ReportObj.addAddress) ? 0.55 : 0.3;

    var TitleBand = new Stimulsoft.Report.Components.StiReportTitleBand();
    TitleBand.name = "TitleBand";
    TitleBand.height = TitleBandHeight;
    page.components.add(TitleBand);

    if (this._reportObject.ReportObj.addLogo) {
      var LogoImage = new Stimulsoft.Report.Components.StiImage(new Stimulsoft.Base.Drawing.RectangleD(0, 0, 0.8, 0.52));
      LogoImage.horAlignment = Stimulsoft.Base.Drawing.StiHorAlignment.Left;
      LogoImage.enabled = true;
      LogoImage.stretch = true;
      LogoImage.name = "TitleLogo";
      LogoImage.imageURL = this._siteLogoUrl;
      LogoImage.printOn = Stimulsoft.Report.Components.StiPrintOnType.OnlyFirstPage;
      TitleBand.setHeight(TitleBandHeight)
      TitleBand.components.add(LogoImage);
    }

    if (this._reportObject.ReportObj.addAddress) {
      var multiLineAddress = (this._siteName ? "{AddressLogoDataSet.SiteName}\n" : "") +
        "{AddressLogoDataSet.Address1}\n" +
        "{AddressLogoDataSet.Address2}\n" +
        "{AddressLogoDataSet.City}, {AddressLogoDataSet.State} {AddressLogoDataSet.Zip}\n" +
        "{AddressLogoDataSet.Country}";
      var addressText = new Stimulsoft.Report.Components.StiText(new Stimulsoft.Base.Drawing.RectangleD(this._reportObject.ReportObj.orientation == "Portrait" ? 4.5 : 7.0, 0, 3.5, 0.55));
      addressText.text = multiLineAddress;
      addressText.horAlignment = Stimulsoft.Base.Drawing.StiTextHorAlignment.Right;
      addressText.vertAlignment = Stimulsoft.Base.Drawing.StiVertAlignment.Top;
      addressText.name = "TitleAddress";
      addressText.font = new Stimulsoft.System.Drawing.Font("Arial", 8, Stimulsoft.System.Drawing.FontStyle.Regular);
      addressText.canGrow = true;
      TitleBand.components.add(addressText);
    }

    var TitleWidth = page.Width;
    var StartTitle = 0;
    var StartHeightTitle = 0;

    if (this._reportObject.ReportObj.addAddress || this._reportObject.ReportObj.addLogo) {
      StartHeightTitle = 0.55;

      if (this._reportObject.ReportObj.addLogo) {
        TitleWidth = TitleWidth - 0.8;
        StartTitle = 0.8;
      }

      if (this._reportObject.ReportObj.addAddress)
        TitleWidth = TitleWidth - 3.7;
    }
    var titleText = new Stimulsoft.Report.Components.StiText();

    titleText.clientRectangle = new Stimulsoft.Base.Drawing.RectangleD(0, this._reportObject.ReportObj.addAddress || this._reportObject.ReportObj.addLogo ? 0.55 : 0, page.width, 0.2);
    titleText.text = (this._reportObject.ReportObj.name as string);
    titleText.horAlignment = Stimulsoft.Base.Drawing.StiTextHorAlignment.Center;
    titleText.name = "HeaderText";
    titleText.font = new Stimulsoft.System.Drawing.Font("Arial", 15, Stimulsoft.System.Drawing.FontStyle.Bold);
    TitleBand.components.add(titleText);

    var headerBand = new Stimulsoft.Report.Components.StiHeaderBand();
    var GroupHeaderBand = new Stimulsoft.Report.Components.StiGroupHeaderBand(new Stimulsoft.Base.Drawing.RectangleD(0, 0, 3.03, 0.27));
    var groupHeaders = [];
    if (this._reportObject.ReportObj.groupBy) {
      groupHeaders = this._reportObject.selectedFields.filter((x: any) => x.gpSelected == true && !x.title.includes("(barcode image)"));
      if (groupHeaders.length == 0) {
        groupHeaders = this._reportObject.selectedFields.filter((x: any) => x.field == (this._reportObject.ReportObj.groupBy) && !x.title.includes("(barcode image)"));
      }

      var columnHeight = Stimulsoft.Base.StiAlignValue.alignToMinGrid(0.27 / (groupHeaders.length), 0.1, true);
      var posY = 0;
      GroupHeaderBand.clientRectangle = new Stimulsoft.Base.Drawing.RectangleD(0, posY, 3.03, columnHeight);
      GroupHeaderBand.name = "GroupHeaderBand";
      GroupHeaderBand.height = 0.2;
      var groupbylabel = this._reportObject.ReportObj.groupBy.includes(".") || this.hasWhiteSpace(this._reportObject.ReportObj.groupBy) ? "[" + this._reportObject.ReportObj.groupBy + "]" : this._reportObject.ReportObj.groupBy;
      GroupHeaderBand.condition = "{root." + groupbylabel + "}";

      var dataText1 = new Stimulsoft.Report.Components.StiText();
      dataText1.canGrow = true;
      dataText1.clientRectangle = new Stimulsoft.Base.Drawing.RectangleD(0.2, posY, 3.03, columnHeight);
      var dataText1label = this._reportObject.ReportObj.groupBy.includes(".") || this.hasWhiteSpace(this._reportObject.ReportObj.groupBy) ? "[" + this._reportObject.ReportObj.groupBy + "]" : this._reportObject.ReportObj.groupBy;
      var GroupByLabelText = this._reportObject.selectedFields.find((x: any) => x.field == this._reportObject.ReportObj.groupBy).title;
      dataText1.text = GroupByLabelText + ":{root." + dataText1label + "}";
      dataText1.name = "GroupHeaderBand" + "_" + dataText1label;
      // dataText1.border.side = Stimulsoft.Base.Drawing.StiBorderSides.Bottom;
      dataText1.font = new Stimulsoft.System.Drawing.Font("Arial", 9, Stimulsoft.System.Drawing.FontStyle.Italic);
      page.components.add(GroupHeaderBand);
      GroupHeaderBand.components.add(dataText1);
      posY += columnHeight;
      var GroupIndex = 1;
      groupHeaders.forEach((element: any) => {
        if (element.field != this._reportObject.ReportObj.groupBy) {
          var dataText1 = new Stimulsoft.Report.Components.StiText();
          dataText1.canGrow = true;
          dataText1.clientRectangle = new Stimulsoft.Base.Drawing.RectangleD(0.2, posY, 3.03, columnHeight);
          var dataText1label = element.field.includes(".") || this.hasWhiteSpace(element.field) ? "[" + element.field + "]" : element.field;
          var GroupByLabelText = this._reportObject.selectedFields.find((x: any) => x.field == element.field).title;
          dataText1.text = GroupByLabelText + ":{root." + dataText1label + "}";
          dataText1.name = "GroupHeader" + GroupIndex;
          dataText1.font = new Stimulsoft.System.Drawing.Font("Arial", 9, Stimulsoft.System.Drawing.FontStyle.Italic);
          // dataText1.border.side = Stimulsoft.Base.Drawing.StiBorderSides.Bottom;
          // GroupHeaderBand.condition += "{root." + element.field + "}"
          //page.components.add(GroupHeaderBand);
          GroupHeaderBand.components.add(dataText1);
          posY += columnHeight;
          GroupIndex++
        }
      });

    }
    else {
      //Create HeaderBand
      headerBand.height = 0.2;
      headerBand.name = "HeaderBand";
      page.components.add(headerBand);
    }

    // Create Databand
    var dataBand = new Stimulsoft.Report.Components.StiDataBand();
    dataBand.dataSourceName = "root";
    dataBand.height = 0.2;
    dataBand.name = "DataBand";
    page.components.add(dataBand);

    var pos = 0;

    if (this.dataSet.tables.list && this.dataSet.tables.list[0]) {
      if (this._reportObject.ReportObj.groupBy) // - 1 to remove the group by column from data
      {
        if (groupHeaders.length == 0)
          var columnWidth = Stimulsoft.Base.StiAlignValue.alignToMinGrid(page.width / (this.dataSet.tables.list[0].columns.count - 1), page.width / (this.dataSet.tables.list[0].columns.count - 1), true);
        else {
          var groupHeadersWithoutGroupBy = groupHeaders.filter((x: any) => x.field != this._reportObject.ReportObj.groupBy);
          var columnWidth = Stimulsoft.Base.StiAlignValue.alignToMinGrid(page.width / (this.dataSet.tables.list[0].columns.count - groupHeadersWithoutGroupBy.length - 1), page.width / (this.dataSet.tables.list[0].columns.count - groupHeadersWithoutGroupBy.length - 1), true);
        }

      }
      else {
        var columnWidth = Stimulsoft.Base.StiAlignValue.alignToMinGrid(page.width / this.dataSet.tables.list[0].columns.count, page.width / this.dataSet.tables.list[0].columns.count, true);
      }

      var nameIndex = 1;
      var dataBandAdded = false;
      for (var index in this.dataSet.tables.list[0].columns.list) {
        var dataColumn = this.dataSet.tables.list[0].columns.list[index];

        let isbarcode = false;

        //Create text on header
        //  if (!this._reportObject.ReportObj.groupBy) {
        if (this._reportObject.ReportObj.groupBy != dataColumn.columnName
          && groupHeaders.filter((x: any) => x.field == dataColumn.columnName).length == 0) {
          var headerText = new Stimulsoft.Report.Components.StiText();
          if (this._reportObject.ReportObj.groupBy)
            headerText.clientRectangle = new Stimulsoft.Base.Drawing.RectangleD(pos, posY, columnWidth, 0.2);
          else
            headerText.clientRectangle = new Stimulsoft.Base.Drawing.RectangleD(pos, 0, columnWidth, 0.2);
          // headerText.clientRectangle = new Stimulsoft.Base.Drawing.RectangleD(pos, 0, columnWidth, 0.5);

          // if(dataColumn.columnName.includes("(barcode image)")){
          //   isbarcode = true
          // }

          // if(isbarcode)
          //     dataColumn.columnName = dataColumn.columnName.replace("(barcode image)", "");

          // if (dataColumn.columnName == dataColumn.caption)
          //   headerText.text = this._reportObject.selectedFields.find((x: any) => x.field == dataColumn.caption).title;

          // else
          //   headerText.text = dataColumn.caption;




          headerText.name = "HeaderText" + nameIndex.toString();
          headerText.horAlignment = Stimulsoft.Base.Drawing.StiTextHorAlignment.Center;
          headerText.border.side = Stimulsoft.Base.Drawing.StiBorderSides.Bottom;
          headerText.font = new Stimulsoft.System.Drawing.Font("Arial", 9, Stimulsoft.System.Drawing.FontStyle.Bold);
          headerBand.components.add(headerText);
          if (this._reportObject.ReportObj.groupBy)
            GroupHeaderBand.components.add(headerText);
          //}
          if (dataColumn.columnName.includes("(barcode image)")) {
            isbarcode = true
          }

          if (isbarcode)
            dataColumn.columnName = dataColumn.columnName.replace("(barcode image)", "");
          //if(!this._reportObject.ReportObj.groupBy)
          //{
          if (dataColumn.columnName == dataColumn.caption) {
            headerText.text = this._reportObject.selectedFields.find((x: any) => x.field == dataColumn.caption).title;

          }
          else {
            headerText.text = dataColumn.caption;

          }
          if (isbarcode && !headerText.text.includes("(barcode image)"))
            headerText.text += "(barcode image)";
          //}

          if (!isbarcode) {
            ////////////////////////////////
            if (this.reportObject.selectedFields.find((x: any) => x.field == dataColumn.columnName && x.type == 'image')) {
              var ImageColumn = new Stimulsoft.Report.Components.StiImage(new Stimulsoft.Base.Drawing.RectangleD(pos, 0, columnWidth, 0.2));
              ImageColumn.horAlignment = Stimulsoft.Base.Drawing.StiHorAlignment.Center;
              var dataTextlabel = dataColumn.columnName.includes(".") || this.hasWhiteSpace(dataColumn.columnName) ? "[" + dataColumn.columnName + "]" : dataColumn.columnName;
              ImageColumn.imageURL = "{root." + dataTextlabel + "}";
              ImageColumn.enabled = true;
              ImageColumn.stretch = true;
              ImageColumn.name = "DataImage" + nameIndex.toString();
              dataBand.components.add(ImageColumn);
              pos = pos + columnWidth;
            }
            ///////////////////////
            else {

              //Create text on Data Band
              var dataText = new Stimulsoft.Report.Components.StiText();
              dataText.clientRectangle = new Stimulsoft.Base.Drawing.RectangleD(pos, 0, columnWidth, 0.2);
              var dataTextlabel = dataColumn.columnName.includes(".") || this.hasWhiteSpace(dataColumn.columnName) ? "[" + dataColumn.columnName + "]" : dataColumn.columnName;
              dataText.text = "{root." + dataTextlabel + "}";
              dataText.name = "DataText" + nameIndex.toString();
              dataText.horAlignment = Stimulsoft.Base.Drawing.StiTextHorAlignment.Center;
              //dataText.border.side = Stimulsoft.Base.Drawing.StiBorderSides.Bottom;
              dataBand.components.add(dataText);
            }

          }

          if (isbarcode) {
            //Create Barcode on Data Band
            var barcode = new Stimulsoft.Report.BarCodes.StiBarCode();
            barcode.clientRectangle = new Stimulsoft.Base.Drawing.RectangleD(pos, 0, columnWidth, 0.4);
            var dataTextlabel = dataColumn.columnName.includes(".") || this.hasWhiteSpace(dataColumn.columnName) ? "[" + dataColumn.columnName + "]" : dataColumn.columnName;
            barcode.code = "{root." + dataTextlabel + "}";
            barcode.name = "DataText" + nameIndex.toString();
            barcode.horAlignment = Stimulsoft.Base.Drawing.StiHorAlignment.Center;
            barcode.barCodeType = new Stimulsoft.Report.BarCodes.StiCode128AutoBarCodeType(10, 0.5);
            dataBand.components.add(barcode)
          }

          pos = pos + columnWidth;

          nameIndex++;
          dataBandAdded = true;
        }
      }
    }

    //Create Group FooterBand
    var footerBand = new Stimulsoft.Report.Components.StiGroupFooterBand();
    if (this._reportObject.ReportObj.groupBy) {
      footerBand.height = 0.2;
      footerBand.name = "FooterBand";
      page.components.add(footerBand);
    }
    //Create text on footer
    var footerText = new Stimulsoft.Report.Components.StiText();
    footerText.clientRectangle = new Stimulsoft.Base.Drawing.RectangleD(0, 0, page.width, 0.2);
    footerText.text = "Count - {Count()}";
    footerText.horAlignment = Stimulsoft.Base.Drawing.StiTextHorAlignment.Center;
    footerText.name = "FooterText";
    //footerText.brush = new Stimulsoft.Base.Drawing.StiSolidBrush(Stimulsoft.System.Drawing.Color.lightGreen);
    footerBand.components.add(footerText);
    this.stimulsoftReport.dictionary.synchronize();
    this.viewer.report = this.stimulsoftReport;

    if (this._definitionOnly) {
      this.returnDefinition.emit(this.stimulsoftReport.saveEncryptedReportToString(environment.reportsKey));
    }
    else {
      this.viewer.renderHtml('viewer');
    }
  }



  getPropertyValueCaseInsensitive(obj: any, keyName: string): any {
    if (!obj || !keyName) return undefined;
    if (obj[keyName] !== undefined) return obj[keyName];
    const lowerKey = keyName.toLowerCase().trim();
    const matchedKey = Object.keys(obj).find(k => k.toLowerCase().trim() === lowerKey);
    return matchedKey ? obj[matchedKey] : undefined;
  }

  private createReportbarcodePreview_3(response: any,
    LabelSizeID: number = null,
    Row: number = null,
    Column: number = null,
    LabelPresetId: number = null,
    LabelSize: any = null,
    isQR = false) {
    LabelSize = LabelSize || { pageWidth: 2, pageHeight: 1, width: 2, height: 1, columns: 1, rows: 1, pageLeftMargin: 0, pageRightMargin: 0, pageTopMargin: 0, pageBottomMargin: 0 };
    this.stimulsoftReport.reportUnit = Stimulsoft.Report.StiReportUnitType.Inches // Inches
    this.stimulsoftReport.width = LabelSize.pageWidth || 2;
    this.stimulsoftReport.height = LabelSize.pageHeight || 1;
    let that = this;
    var xobject = {};

    //New Read Data
    var xobject = {};
    let allFields: any[] = [];
    let allbarcodeFields: any[] = [];
    var getSelectedFields2: any = [];
    that._reportObject.selectedFields.forEach((element: any) => {
      if (!element.title.includes("(barcode image)"))
        allFields.push(element.field);
      if (element.title.includes("(barcode image)"))
        allFields.push(element.field + "(barcode image)");
    });
    if (response && response.length > 0) {
      response = response.slice(0, 20);
      var getSelectedFields: any[] = [];
      response.forEach((element: any) => {
        if (allFields) {
          xobject = {};
          for (let field of allFields) {
            const cleanField = field.replace("(barcode image)", "").trim();
            (xobject as any)[field] = this.getPropertyValueCaseInsensitive(element, cleanField) ?? this.getPropertyValueCaseInsensitive(element, field) ?? "";
          }
          getSelectedFields.push(xobject);
        }
      });
      /* var getSelectedFields = Array.prototype.map.call((response as Array<any>), function (item: any) {
        if (allFields){
          for (let field of allFields) {
              (xobject as any)[field] = item[field];
            return xobject;
  
            }
        }
        // if (allbarcodeFields){
        //   for (let field of allbarcodeFields) {
        //       (xobject as any)[field] = item[field.replace("(barcode image)","")];
        //   }
        // }
  
      }); */

      this.dataSet.readJson(getSelectedFields);
    }
    else if (response != null) {
      var modelObject = {};
      var stringObject = "{";
      allFields.forEach((element: string) => {
        stringObject += "\"" + element + "\":\"\",";
      });
      stringObject = stringObject.substring(0, stringObject.length - 1);
      stringObject += "}";
      modelObject = JSON.parse(stringObject);
      this.dataSet.readJson(modelObject);
    }

    // this.dataSet.tables.list[0].rows = 20;
    this.stimulsoftReport.regData(this.dataSet.dataSetName, '', this.dataSet);

    var page = this.stimulsoftReport.pages.getByIndex(0);
    page.height = LabelSize.height;
    var columnWidth = Stimulsoft.Base.StiAlignValue.alignToMinGrid(page.width / this.dataSet.tables.list[0].columns.count, 0.1, true);
    // Create Databand
    var dataBand = new Stimulsoft.Report.Components.StiDataBand();
    dataBand.dataSourceName = "root";
    dataBand.height = page.height;
    dataBand.name = "DataBand";

    if (LabelSizeID) // Not Custom Size
    {
      dataBand.columns = LabelSize.columns;
      dataBand.columnWidth = LabelSize.width;
      dataBand.columnGaps = LabelSize.columnGaps;
    }

    // dataBand.columnDirection = 0;
    page.components.add(dataBand);
    var nameIndex = 1;
    var pos = 0;

    var isbarcode = false;
    let i = 0;
    let posY = 0;

    // HeightCode = page.height / allFields.length;
    // posY += HeightCode;
    let _Width = LabelSize.width;
    let _Height = LabelSize.height;
    let _PageWidth = LabelSize.pageWidth;
    let _PageHeight = LabelSize.pageHeight;
    let VerticalPitch = LabelSize.verticalPitch;
    let VerticalMargin = LabelSize.verticalMargin;
    let HorizontalMargin = LabelSize.horizontalMargin;
    let Columns = LabelSize.columns;
    let Rows = LabelSize.rows;
    // Old
    // page.width = _PageWidth - 0.78;
    // page.height = _PageHeight - 0.78;
    // page.margins.left = 0;
    // page.margins.bottom = 0;
    // page.margins.right = 0;
    // page.margins.top = VerticalMargin;
    // New
    page.margins.left = LabelSize.pageLeftMargin;
    page.margins.bottom = LabelSize.pageBottomMargin;
    page.margins.right = LabelSize.pageRightMargin;
    page.margins.top = LabelSize.pageTopMargin;
    //    page.width = _PageWidth;
    //  page.height = _PageHeight;
    page._width = _PageWidth;
    page._height = _PageHeight;
    //page._paperSize = 1;
    page._pageWidth = _PageWidth;
    page._pageHeight = _PageHeight;
    page.pageWidth = _PageWidth;
    page.pageHeight = _PageHeight;
    page.unlimitedHeight = false;
    //page._unlimitedWidth = false;
    //  page._shiftMode  = 0;
    //page._columns = Columns;
    page.reportUnit = Stimulsoft.Report.StiReportUnitType.Inches // Inches
    // page._columnGaps = 0.19;

    columnWidth = _Width;
    //dataBand.columnWidth = columnWidth;
    //Create text on Data Band

    //  if(that._reportObject.ReportObj.filterBy)
    //  {
    //   that._reportObject.ReportObj.filterBy = that._reportObject.ReportObj.filterBy.substring(that._reportObject.ReportObj.filterBy.indexOf('.')+1)
    //   if(that._reportObject.ReportObj.filterBy.includes("(barcode image)"))
    //   {
    //     var barcode = new Stimulsoft.Report.BarCodes.StiBarCode((new Stimulsoft.Base.Drawing.RectangleD(0, 0, _Width, 0.2)));
    //     var dataTextlabel = that._reportObject.ReportObj.filterBy.includes(".") ? "[" + that._reportObject.ReportObj.filterBy + "]" : that._reportObject.ReportObj.filterBy;
    //      if(dataTextlabel.includes("(barcode image)"))
    //      dataTextlabel = dataTextlabel.replace("(barcode image)", "");
    //     barcode.code = "{root." + dataTextlabel + "}";
    //     barcode.name = "DataText" + nameIndex.toString();
    //     if (!isQR){
    //     barcode.horAlignment = Stimulsoft.Base.Drawing.StiHorAlignment.Center;
    //     barcode.vertAlignment = Stimulsoft.Base.Drawing.StiVertAlignment.Center;
    //     barcode.autoScale = false;
    //     barcode.showLabelText = true;
    //     if (LabelSizeID == 1)
    //     barcode.barCodeType = new Stimulsoft.Report.BarCodes.StiCode128AutoBarCodeType(10, 0.65);
    //     else
    //     barcode.barCodeType = new Stimulsoft.Report.BarCodes.StiCode128AutoBarCodeType(10, 0.85);
    //     }
    //     else{
    //     barcode.horAlignment = Stimulsoft.Base.Drawing.StiHorAlignment.Center;
    //     barcode.vertAlignment = Stimulsoft.Base.Drawing.StiVertAlignment.Center;
    //     barcode.autoScale = true;
    //     barcode.showLabelText = true;
    //     barcode.barCodeType = new Stimulsoft.Report.BarCodes.StiQRCodeBarCodeType();
    //     }
    //     dataBand.components.add(barcode);
    //   }
    //   else
    //   {
    //     var dataText = new Stimulsoft.Report.Components.StiText();
    //     dataText.clientRectangle = new Stimulsoft.Base.Drawing.RectangleD(pos, 0, columnWidth, 0.2);
    //     var dataTextlabel0 = that._reportObject.ReportObj.filterBy.includes(".") ? "[" + that._reportObject.ReportObj.filterBy + "]" : that._reportObject.ReportObj.filterBy;
    //      //dataColumn.columnName.includes(".") ? "[" + dataColumn.columnName + "]" : dataColumn.columnName;
    //     dataText.text = "{root." + dataTextlabel0 + "}";
    //     dataText.name = "DataText" + nameIndex.toString()
    //     dataText.horAlignment = Stimulsoft.Base.Drawing.StiTextHorAlignment.Center;
    //     dataText.vertAlignment =Stimulsoft.Base.Drawing.StiVertAlignment.Center;;
    //      dataBand.components.add(dataText);
    //   }

    //  }
    let Zebra = false;

    if (LabelSizeID >= 11 && LabelSizeID < 22)
      Zebra = true;
    if (!LabelSizeID) // Custom Size
      Zebra = true;
    //  if(that._reportObject.ReportObj.filterBy)
    //  {
    //   if(!Zebra)
    //   {
    //     posY = posY + 0.2;
    //   }
    //   else
    //   {
    //     posY = posY + 0.2;
    //   }
    //  }
    let HeightCode = 0;
    posY = 0;
    //if(!Zebra)

    HeightCode = _Height / allFields.length;
    if (allbarcodeFields.length > 0)
      HeightCode = HeightCode - 0.05;
    // if(Zebra)
    // posY += 0.2;
    for (var index in this.dataSet.tables.list[0].columns.list) {

      var dataColumn = this.dataSet.tables.list[0].columns.list[index];
      if (i == 0 && dataColumn.columnName.includes("(barcode image)") && !Zebra) {
        posY = 0;
      }
      if (dataColumn.columnName.includes("(barcode image)")) {
        isbarcode = true;
        const oldColName = dataColumn.columnName;
        const newColName = dataColumn.columnName.replace("(barcode image)", "");
        dataColumn.columnName = newColName;
        if (this.dataSet?.tables?.list[0]?.rows) {
          for (let r = 0; r < this.dataSet.tables.list[0].rows.count; r++) {
            const row = this.dataSet.tables.list[0].rows.list[r];
            if (row && row[oldColName] !== undefined) {
              row[newColName] = row[oldColName];
            }
          }
        }
      }
      else isbarcode = false;

      //if(!isbarcode)
      //dataBand.components.add(dataText);
      // labelSizes




      if (!Zebra) {

        columnWidth = _PageWidth / Columns;
        let _columnWidth = 0;
        //let posY = 0;

        let rows = 0;
        let pageNumber = 0;
        let FlagColumns = 1;
        let Flags = 1;
        let _Columns = Columns;
        let FirstColumnWidth = 0;
        let FirstPosy = 0;
        let dbHeight = 0;
        //dbHeight = VerticalMargin;


        let CodeHeight = _Height;
        if (isbarcode) {
          var barcode = new Stimulsoft.Report.BarCodes.StiBarCode((new Stimulsoft.Base.Drawing.RectangleD(0, posY, _Width, HeightCode)));
          var dataTextlabel = dataColumn.columnName.includes(".") || this.hasWhiteSpace(dataColumn.columnName) ? "[" + dataColumn.columnName + "]" : dataColumn.columnName;
          barcode.code = "{root." + dataTextlabel + "}";
          barcode.name = "DataText" + nameIndex.toString();

          if (!isQR) {
            barcode.horAlignment = Stimulsoft.Base.Drawing.StiHorAlignment.Center;
            barcode.vertAlignment = Stimulsoft.Base.Drawing.StiVertAlignment.Center;
            barcode.autoScale = true;
            barcode.showLabelText = true;
            if (LabelSizeID == 1)
              barcode.barCodeType = new Stimulsoft.Report.BarCodes.StiCode128AutoBarCodeType(10, HeightCode);
            else
              barcode.barCodeType = new Stimulsoft.Report.BarCodes.StiCode128AutoBarCodeType(10, HeightCode);
          }
          else {
            barcode.horAlignment = Stimulsoft.Base.Drawing.StiHorAlignment.Center;
            barcode.vertAlignment = Stimulsoft.Base.Drawing.StiVertAlignment.Center;
            barcode.autoScale = true;
            barcode.showLabelText = true;
            barcode.barCodeType = new Stimulsoft.Report.BarCodes.StiQRCodeBarCodeType();
          }
          //if(dataColumn.columnName != that._reportObject.ReportObj.filterBy.replace("(barcode image)", ""))
          //{
          dataBand.components.add(barcode);
          //posY = posY + 0.2;
          //}

        }

        else {
          var dataText2 = new Stimulsoft.Report.Components.StiText();
          dataText2.clientRectangle = new Stimulsoft.Base.Drawing.RectangleD(0, posY, _Width, HeightCode);
          var dataTextlabel = dataColumn.columnName.includes(".") || this.hasWhiteSpace(dataColumn.columnName) ? "[" + dataColumn.columnName + "]" : dataColumn.columnName;
          dataText2.horAlignment = Stimulsoft.Base.Drawing.StiTextHorAlignment.Center;
          dataText2.vertAlignment = Stimulsoft.Base.Drawing.StiVertAlignment.Center;
          dataText2.text = "{root." + dataTextlabel + "}";
          dataText2.name = "DT" + nameIndex.toString();
          //dataText.top = posY;
          // if(dataColumn.columnName != that._reportObject.ReportObj.filterBy)
          // {
          dataBand.components.add(dataText2);
          //posY = posY + 0.2;
          //}

        }
        posY += HeightCode;
      }
      else {
        // page.margins.top = 0;

        pos = 0;
        //let posY = 0;
        let dbHeight = 0;
        dbHeight = VerticalPitch;
        columnWidth = Math.round(columnWidth);
        // page.Height = Math.round(_Height)

        // page._height =  Math.round(_PageHeight) ;
        // page._pageHeight =  Math.round(_PageHeight);
        // page.pageHeight =  Math.round(_PageHeight);
        let rectX = 0;
        if (LabelSizeID == 12)//Zebra 2x1
          rectX = -0.034;
        // if (LabelSizeID == 12)//Zebra 2x1
        //   rectX = -0.034;

        // let rectY = 0;
        // let BarcodeHeight = 0.85;

        // if (LabelSizeID == 11 || LabelSizeID == 21)//Zebra 3x1 || Zebra 3x2
        //     rectX = -0.02;
        // else if (LabelSizeID == 12)//Zebra 2x1
        //     rectX = -0.034;
        // else if (LabelSizeID == 15)//Zebra 1.5x0.5
        // {
        //   rectX = -0.025;
        //   rectY = rectY + 0.1;
        //   BarcodeHeight = 0.65;
        //   _Height = _Height - 0.1;
        // }
        // else if (LabelSizeID == 16)//Zebra 2x1.25
        // {
        // rectX = -0.034;
        // BarcodeHeight = 0.9;
        // }

        let CodeHeight = _Height;

        //   let barcode = new Stimulsoft.Report.BarCodes.StiBarCode(new Stimulsoft.Base.Drawing.RectangleD(rectX, posY, columnWidth, _Height));
        //   var dataTextlabel = dataColumn.columnName.includes(".") ? "[" + dataColumn.columnName + "]" : dataColumn.columnName;
        //   barcode.code = "{root." + dataTextlabel + "}";
        //   barcode.name = "DataText" + nameIndex.toString();


        // if (!isQR)
        // {
        //   barcode.horAlignment = Stimulsoft.Base.Drawing.StiHorAlignment.Center;
        //   barcode.vertAlignment = Stimulsoft.Base.Drawing.StiVertAlignment.Center;
        //   barcode.autoScale = false;
        //   barcode.showLabelText = true;
        //   barcode.barCodeType = new Stimulsoft.Report.BarCodes.StiCode128AutoBarCodeType(10, 0.2);
        // }
        // else
        // {
        //   barcode.horAlignment = Stimulsoft.Base.Drawing.StiHorAlignment.Center;
        //   barcode.vertAlignment = Stimulsoft.Base.Drawing.StiVertAlignment.Center;
        //   barcode.autoScale = true;
        //   barcode.showLabelText = true;
        //   barcode.barCodeType = new Stimulsoft.Report.BarCodes.StiCode128AutoBarCodeType();
        // }
        if (isbarcode) {
          var barcode = new Stimulsoft.Report.BarCodes.StiBarCode((new Stimulsoft.Base.Drawing.RectangleD(rectX, posY, _Width, HeightCode)));
          var dataTextlabel = dataColumn.columnName.includes(".") || this.hasWhiteSpace(dataColumn.columnName) ? "[" + dataColumn.columnName + "]" : dataColumn.columnName;
          barcode.code = "{root." + dataTextlabel + "}";
          barcode.name = "DataText" + nameIndex.toString();

          if (!isQR) {
            barcode.horAlignment = Stimulsoft.Base.Drawing.StiHorAlignment.Center;
            barcode.vertAlignment = Stimulsoft.Base.Drawing.StiVertAlignment.Center;
            barcode.autoScale = true;
            barcode.showLabelText = true;

            if (LabelSizeID == 1)
              barcode.barCodeType = new Stimulsoft.Report.BarCodes.StiCode128AutoBarCodeType(10, HeightCode);
            else
              barcode.barCodeType = new Stimulsoft.Report.BarCodes.StiCode128AutoBarCodeType(10, HeightCode);
          }
          else {
            barcode.horAlignment = Stimulsoft.Base.Drawing.StiHorAlignment.Center;
            barcode.vertAlignment = Stimulsoft.Base.Drawing.StiVertAlignment.Center;
            barcode.autoScale = true;
            barcode.showLabelText = true;
            barcode.barCodeType = new Stimulsoft.Report.BarCodes.StiQRCodeBarCodeType();
          }
          //if(dataColumn.columnName != that._reportObject.ReportObj.filterBy.replace("(barcode image)", ""))
          // {
          dataBand.components.add(barcode);
          posY += HeightCode;
          // posY = posY + 0.2;
          //}
        }

        else {
          var dataText2 = new Stimulsoft.Report.Components.StiText();
          dataText2.clientRectangle = new Stimulsoft.Base.Drawing.RectangleD(rectX, posY, _Width, HeightCode);
          var dataTextlabel = dataColumn.columnName.includes(".") || this.hasWhiteSpace(dataColumn.columnName) ? "[" + dataColumn.columnName + "]" : dataColumn.columnName;
          dataText2.horAlignment = Stimulsoft.Base.Drawing.StiTextHorAlignment.Center;
          dataText2.vertAlignment = Stimulsoft.Base.Drawing.StiVertAlignment.Center;
          dataText2.text = "{root." + dataTextlabel + "}";
          dataText2.name = "DT" + nameIndex.toString();
          dataText2.font = new Stimulsoft.System.Drawing.Font("Arial", 10, Stimulsoft.System.Drawing.FontStyle.Regular);
          //if(dataColumn.columnName != that._reportObject.ReportObj.filterBy)
          //{
          dataBand.components.add(dataText2);
          // posY = posY + 0.2;
          //}
          // if(allbarcodeFields.length > 0)
          // posY += HeightCode * 2;
          // else
          posY += HeightCode;
        }


      }

      // labelSizesEnd


      //Create Barcode on Data Band
      // var barcode = new Stimulsoft.Report.BarCodes.StiBarCode((new Stimulsoft.Base.Drawing.RectangleD(pos, 0, _Width, _Height)));
      // var dataTextlabel = dataColumn.columnName.includes(".") ? "[" + dataColumn.columnName + "]" : dataColumn.columnName;
      // barcode.horAlignment = Stimulsoft.Base.Drawing.StiHorAlignment.Center;
      // barcode.vertAlignment = Stimulsoft.Base.Drawing.StiVertAlignment.Center;
      // barcode.code = "{root." + dataTextlabel + "}";
      // barcode.name = "DataText" + nameIndex.toString();
      // barcode.width = _Width;
      // barcode.height = _Height;
      // barcode.autoScale = false;
      // barcode.showLabelText = true;
      // barcode.barCodeType = new Stimulsoft.Report.BarCodes.StiCode128AutoBarCodeType(10, _Height);

      // dataBand.components.add(barcode);
      pos = pos + columnWidth;
      nameIndex++;
      i++;
    }
    page.invokeRendering();
    this._windowMode = true;
    this.options.toolbar.visible = true;
    this.options.toolbar.zoom = 0;
    this.stimulsoftReport.dictionary.synchronize();
    this.viewer.report = this.stimulsoftReport;
    this.viewer.renderHtml('viewer');
    this.returnDefinition.emit(this.stimulsoftReport.saveEncryptedReportToString(environment.reportsKey));
  }
  private createReportbarcodePreviewWithReportDefinition(response: any,
    LabelSizeID: number = null,
    Row: number = null,
    Column: number = null,
    LabelPresetId: number = null,
    LabelSize: any = null,
    isQR = false) {

    LabelSize = LabelSize || { pageWidth: 2, pageHeight: 1, width: 2, height: 1, columns: 1, rows: 1, pageLeftMargin: 0, pageRightMargin: 0, pageTopMargin: 0, pageBottomMargin: 0 };
    this.stimulsoftReport.reportUnit = Stimulsoft.Report.StiReportUnitType.Inches // Inches
    this.stimulsoftReport.width = LabelSize.pageWidth || 2;
    this.stimulsoftReport.height = LabelSize.pageHeight || 1;
    let that = this;
    var xobject = {};

    //New Read Data
    var xobject = {};
    let allFields: any[] = [];
    let allbarcodeFields: any[] = [];
    var getSelectedFields2: any = [];
    that._reportObject.selectedFields.forEach((element: any) => {
      if (!element.title.includes("(barcode image)"))
        allFields.push(element.field);
      if (element.title.includes("(barcode image)"))
        allFields.push(element.field + "(barcode image)");
    });

    that._reportObject.selectedFields.forEach((element: any) => {
      if (element.title.includes("(barcode image)"))
        allbarcodeFields.push(element.field + "(barcode image)");
    });
    if (response && response.length > 0) {
      // limit to 20 rows displayed on the page.
      response = response.slice(0, 20);
      var getSelectedFields: any[] = [];
      response.forEach((element: any) => {
        if (allFields) {
          xobject = {};
          for (let field of allFields) {
            const cleanField = field.replace("(barcode image)", "").trim();
            (xobject as any)[field] = this.getPropertyValueCaseInsensitive(element, cleanField) ?? this.getPropertyValueCaseInsensitive(element, field) ?? "";
          }
          getSelectedFields.push(xobject);
        }
      });


      this.dataSet.readJson(getSelectedFields);
    }
    else if (response != null) {
      var modelObject = {};
      var stringObject = "{";
      allFields.forEach((element: string) => {
        stringObject += "\"" + element + "\":\"\",";
      });
      stringObject = stringObject.substring(0, stringObject.length - 1);
      stringObject += "}";
      modelObject = JSON.parse(stringObject);
      this.dataSet.readJson(modelObject);
    }

    this.stimulsoftReport.regData(this.dataSet.dataSetName, '', this.dataSet);

    var page = this.stimulsoftReport.pages.getByIndex(0);
    const dataBand = page.components.list.find((component: any) => {
      return component &&
        component.name === 'DataBand';
    })
    page.height = LabelSize.height;
    var columnWidth = Stimulsoft.Base.StiAlignValue.alignToMinGrid(page.width / this.dataSet.tables.list[0].columns.count, 0.1, true);
    // Create Databand



    var nameIndex = 1;
    var pos = 0;

    var isbarcode = false;
    let i = 0;
    let posY = 0;

    let _Width = LabelSize.width;
    let _Height = LabelSize.height;
    let _PageWidth = LabelSize.pageWidth;
    let _PageHeight = LabelSize.pageHeight;
    let VerticalPitch = LabelSize.verticalPitch;
    let VerticalMargin = LabelSize.verticalMargin;
    let HorizontalMargin = LabelSize.horizontalMargin;
    let Columns = LabelSize.columns;
    let Rows = LabelSize.rows;

    page.margins.left = LabelSize.pageLeftMargin;
    page.margins.bottom = LabelSize.pageBottomMargin;
    page.margins.right = LabelSize.pageRightMargin;
    page.margins.top = LabelSize.pageTopMargin;

    page._width = _PageWidth;
    page._height = _PageHeight;

    page._pageWidth = _PageWidth;
    page._pageHeight = _PageHeight;
    page.pageWidth = _PageWidth;
    page.pageHeight = _PageHeight;
    page.unlimitedHeight = false;

    page.reportUnit = Stimulsoft.Report.StiReportUnitType.Inches // Inches


    columnWidth = _Width;

    let Zebra = false;

    if (LabelSizeID >= 11 && LabelSizeID < 22)
      Zebra = true;
    if (!LabelSizeID) // Custom Size
      Zebra = true;

    let HeightCode = 0;
    posY = 0;


    HeightCode = _Height / allFields.length;
    if (allbarcodeFields.length > 0)
      HeightCode = HeightCode - 0.05;
    for (var index in this.dataSet.tables.list[0].columns.list) {

      var dataColumn = this.dataSet.tables.list[0].columns.list[index];
      if (i == 0 && dataColumn.columnName.includes("(barcode image)") && !Zebra) {
        posY = 0;
      }
      if (dataColumn.columnName.includes("(barcode image)")) {
        isbarcode = true;
        const oldColName = dataColumn.columnName;
        const newColName = dataColumn.columnName.replace("(barcode image)", "");
        dataColumn.columnName = newColName;
        if (this.dataSet?.tables?.list[0]?.rows) {
          for (let r = 0; r < this.dataSet.tables.list[0].rows.count; r++) {
            const row = this.dataSet.tables.list[0].rows.list[r];
            if (row && row[oldColName] !== undefined) {
              row[newColName] = row[oldColName];
            }
          }
        }
      }
      else isbarcode = false;

      if (!Zebra) {

        columnWidth = _PageWidth / Columns;

        if (isbarcode) {
          var barcode = new Stimulsoft.Report.BarCodes.StiBarCode((new Stimulsoft.Base.Drawing.RectangleD(0, posY, _Width, HeightCode)));
          var dataTextlabel = dataColumn.columnName.includes(".") || this.hasWhiteSpace(dataColumn.columnName) ? "[" + dataColumn.columnName + "]" : dataColumn.columnName;
          barcode.code = "{root." + dataTextlabel + "}";
          barcode.name = "DataText" + nameIndex.toString();

          if (!isQR) {
            barcode.horAlignment = Stimulsoft.Base.Drawing.StiHorAlignment.Center;
            barcode.vertAlignment = Stimulsoft.Base.Drawing.StiVertAlignment.Center;
            barcode.autoScale = true;
            barcode.showLabelText = true;
            if (LabelSizeID == 1)
              barcode.barCodeType = new Stimulsoft.Report.BarCodes.StiCode128AutoBarCodeType(10, HeightCode);
            else
              barcode.barCodeType = new Stimulsoft.Report.BarCodes.StiCode128AutoBarCodeType(10, HeightCode);
          }
          else {
            barcode.horAlignment = Stimulsoft.Base.Drawing.StiHorAlignment.Center;
            barcode.vertAlignment = Stimulsoft.Base.Drawing.StiVertAlignment.Center;
            barcode.autoScale = true;
            barcode.showLabelText = true;
            barcode.barCodeType = new Stimulsoft.Report.BarCodes.StiQRCodeBarCodeType();
          }
          var ExistDataBand = dataBand.components.list.find((x: any) => x.name.includes('DataText') && x.code == barcode.code)
          if (!ExistDataBand)
            dataBand.components.add(barcode);
          else {

            ExistDataBand.height = HeightCode;
            ExistDataBand.top = posY;
            ExistDataBand.barCodeType = new Stimulsoft.Report.BarCodes.StiCode128AutoBarCodeType(10, HeightCode);
          }



        }

        else {
          var dataText2 = new Stimulsoft.Report.Components.StiText();
          dataText2.clientRectangle = new Stimulsoft.Base.Drawing.RectangleD(0, posY, _Width, HeightCode);
          var dataTextlabel = dataColumn.columnName.includes(".") || this.hasWhiteSpace(dataColumn.columnName) ? "[" + dataColumn.columnName + "]" : dataColumn.columnName;
          dataText2.horAlignment = Stimulsoft.Base.Drawing.StiTextHorAlignment.Center;
          dataText2.vertAlignment = Stimulsoft.Base.Drawing.StiVertAlignment.Center;
          dataText2.text = "{root." + dataTextlabel + "}";
          dataText2.name = "DT" + nameIndex.toString();
          var ExistDataBand = dataBand.components.list.find((x: any) => x.name.includes('DT') && x.text == dataText2.text)
          if (!ExistDataBand)
            dataBand.components.add(dataText2);
          else {
            ExistDataBand.height = HeightCode;
            ExistDataBand.top = posY;
          }


        }
        posY += HeightCode;
      }
      else {

        pos = 0;
        let dbHeight = 0;
        dbHeight = VerticalPitch;
        columnWidth = Math.round(columnWidth);

        let rectX = 0;
        if (LabelSizeID == 12)//Zebra 2x1
          rectX = -0.034;

        if (isbarcode) {
          var barcode = new Stimulsoft.Report.BarCodes.StiBarCode((new Stimulsoft.Base.Drawing.RectangleD(rectX, posY, _Width, HeightCode)));
          var dataTextlabel = dataColumn.columnName.includes(".") || this.hasWhiteSpace(dataColumn.columnName) ? "[" + dataColumn.columnName + "]" : dataColumn.columnName;
          barcode.code = "{root." + dataTextlabel + "}";
          barcode.name = "DataText" + nameIndex.toString();

          if (!isQR) {
            barcode.horAlignment = Stimulsoft.Base.Drawing.StiHorAlignment.Center;
            barcode.vertAlignment = Stimulsoft.Base.Drawing.StiVertAlignment.Center;
            barcode.autoScale = true;
            barcode.showLabelText = true;

            if (LabelSizeID == 1)
              barcode.barCodeType = new Stimulsoft.Report.BarCodes.StiCode128AutoBarCodeType(10, HeightCode);
            else
              barcode.barCodeType = new Stimulsoft.Report.BarCodes.StiCode128AutoBarCodeType(10, HeightCode);
          }
          else {
            barcode.horAlignment = Stimulsoft.Base.Drawing.StiHorAlignment.Center;
            barcode.vertAlignment = Stimulsoft.Base.Drawing.StiVertAlignment.Center;
            barcode.autoScale = true;
            barcode.showLabelText = true;
            barcode.barCodeType = new Stimulsoft.Report.BarCodes.StiQRCodeBarCodeType();
          }
          var ExistDataBand = dataBand.components.list.find((x: any) => x.name.includes('DataText') && x.code == barcode.code)
          if (!ExistDataBand)
            dataBand.components.add(barcode);
          else {

            ExistDataBand.height = HeightCode;
            ExistDataBand.top = posY;
            ExistDataBand.barCodeType = new Stimulsoft.Report.BarCodes.StiCode128AutoBarCodeType(10, HeightCode);
          }
          posY += HeightCode;

        }

        else {
          var dataText2 = new Stimulsoft.Report.Components.StiText();
          dataText2.clientRectangle = new Stimulsoft.Base.Drawing.RectangleD(rectX, posY, _Width, HeightCode);
          var dataTextlabel = dataColumn.columnName.includes(".") || this.hasWhiteSpace(dataColumn.columnName) ? "[" + dataColumn.columnName + "]" : dataColumn.columnName;
          dataText2.horAlignment = Stimulsoft.Base.Drawing.StiTextHorAlignment.Center;
          dataText2.vertAlignment = Stimulsoft.Base.Drawing.StiVertAlignment.Center;
          dataText2.text = "{root." + dataTextlabel + "}";
          dataText2.name = "DT" + nameIndex.toString();
          dataText2.font = new Stimulsoft.System.Drawing.Font("Arial", 10, Stimulsoft.System.Drawing.FontStyle.Regular);
          var ExistDataBand = dataBand.components.list.find((x: any) => x.name.includes('DT') && x.text == dataText2.text)
          if (!ExistDataBand)
            dataBand.components.add(dataText2);
          else {
            ExistDataBand.height = HeightCode;
            ExistDataBand.top = posY;
          }

          posY += HeightCode;
        }


      }


      pos = pos + columnWidth;
      nameIndex++;
      i++;
    }
    page.invokeRendering();
    //   this._windowMode = true;
    //   this.options.toolbar.visible = true;
    //   this.options.toolbar.zoom = 0;
    //this.stimulsoftReport.dictionary.synchronize();
    //   this.viewer.report = this.stimulsoftReport;
    //   this.viewer.renderHtml('viewer');
    this.returnDefinition.emit(this.stimulsoftReport.saveEncryptedReportToString(environment.reportsKey));
  }






  public Barcode_PrePrintBarcodes(BarcodeValues: any[], LabelSizeID: number, Row: number, Column: number, LabelPresetId: number = null, LabelSize: any, NumberOfCopies: number) {
    if (!NumberOfCopies)
      NumberOfCopies = 1;
    let isQR = false;
    // Row = 1;
    // Column = 1;
    let columnWidth: number;
    this.stimulsoftReport.reportUnit = Stimulsoft.Report.StiReportUnitType.Inches // Inches
    let page = this.stimulsoftReport.pages.getByIndex(0);

    if (LabelPresetId == null) {

      let _Width = LabelSize.width;
      let _Height = LabelSize.height;
      // let _Width = 1.70;
      // let _Height = 0.5;
      let _PageWidth = LabelSize.pageWidth;//LabelSize.pageWidth;
      let _PageHeight = LabelSize.pageHeight//; LabelSize.pageHeight;
      let VerticalPitch = LabelSize.verticalPitch;
      let VerticalMargin = LabelSize.verticalMargin;
      let HorizontalMargin = LabelSize.horizontalMargin;
      let Columns = LabelSize.columns;
      let Rows = LabelSize.rows;


      page.margins.left = LabelSize.pageLeftMargin;
      page.margins.bottom = LabelSize.pageBottomMargin;
      page.margins.right = LabelSize.pageRightMargin;

      page.margins.top = VerticalMargin;
      page.unlimitedHeight = false;

      page._pageWidth = _PageWidth;
      page._pageHeight = _PageHeight;
      page.pageWidth = _PageWidth;
      page.pageHeight = _PageHeight;
      let Zebra = false;

      if (LabelSizeID >= 11 && LabelSizeID < 22)
        Zebra = true;
      if (!LabelSizeID) {
        Zebra = true;
      }
      if (Zebra == false) {
        if (NumberOfCopies > 1)
          BarcodeValues = this.HandleAveryLabelSizeForMultipleCopies(BarcodeValues, NumberOfCopies);
      }
      else {
        page._numberOfCopies = NumberOfCopies;
      }

      columnWidth = _Width;

      let ds = new Stimulsoft.System.Data.DataSet('DataSet');

      this.dataSet.readJson(BarcodeValues as Array<any>);
      this.stimulsoftReport.regData(this.dataSet.dataSetName, '', this.dataSet);
      this.stimulsoftReport.dictionary.synchronize();



      if (!Zebra) {
        page._pageHeight = page._pageHeight + 0.3;
        page.pageHeight = page.pageHeight + 0.3;
        let dataBand = new Stimulsoft.Report.Components.StiDataBand();
        columnWidth = _PageWidth / Columns;
        let _columnWidth = 0;
        let posY = 0;
        let rows = 0;
        let pageNumber = 0;
        let FlagColumns = 1;
        let Flags = 1;
        let _Columns = Columns;
        let FirstColumnWidth = 0;
        let FirstPosy = 0;
        let dbHeight = 0;
        dbHeight = VerticalPitch;

        let AllRows = Rows;
        // for(let n = 0; n < NumberOfCopies; n++)
        // {
        for (let i = 0; i < BarcodeValues.length; i++) {


          if (i == 0) {
            rows = Row - 1;

            // rows = Row;
            dataBand = new Stimulsoft.Report.Components.StiDataBand(new Stimulsoft.Base.Drawing.RectangleD(0, 0, _Width, dbHeight));
            dataBand.height = 0.5;
            dataBand.name = "DataBand";
            page.components.add(dataBand);

            if (LabelSizeID == 1)//Avery 5167 template => 4 Columns
            {
              if (Column != 1) {
                FlagColumns = Column;
                if (Column == 2)
                  _columnWidth = columnWidth * (Column - 1) - 0.05;
                else if (Column == 3)
                  _columnWidth = columnWidth * (Column - 1) - 0.13;
                else if (Column == 4)
                  _columnWidth = columnWidth * (Column - 1) - 0.2;
              }
              else
                _columnWidth = 0.05;

              FirstColumnWidth = 0.05;
            }
            else if (LabelSizeID == 2)//Avery 5160 template => 3 Columns
            {
              if (Column != 1) {
                FlagColumns = Column;
                if (Column == 2)
                  _columnWidth = columnWidth * (Column - 1) - 0.02;
                else if (Column == 3)
                  _columnWidth = columnWidth * (Column - 1) - 0.1;
              }
              else
                _columnWidth = 0.08;

              FirstColumnWidth = 0.08;
            }
            //Avery 5161 template || Avery 5162 template || Avery 5163 template || Avery 5164 template ==> 2 Columns
            else if (LabelSizeID == 5 || LabelSizeID == 6 || LabelSizeID == 7 || LabelSizeID == 9) {
              if (Column != 1) {
                FlagColumns = Column;
                _columnWidth = columnWidth * (Column - 1) - 0.05;
              }
              else {
                _columnWidth = 0.02;
              }

              FirstColumnWidth = 0.02;
            }
            if (LabelSizeID == 22)//Avery 6576 template => 4 Columns
            {
              if (Column != 1) {
                FlagColumns = Column;
                if (Column == 2)
                  _columnWidth = columnWidth * (Column - 1) + 0.04;
                else if (Column == 3)
                  _columnWidth = columnWidth * (Column - 1) - 0.14;
                else if (Column == 4)
                  _columnWidth = columnWidth * (Column - 1) - 0.34;
              }
              else {
                _columnWidth = 0.22;
              }

              FirstColumnWidth = 0.22;
            }
            else if (LabelSizeID == 10) //Avery 5389 template
            {
              FlagColumns = Column;
              _columnWidth = -0.04;
              FirstColumnWidth = -0.04;
            }
            else if (LabelSizeID == 8) //Avery 5384 template
            {
              if (Column != 1) {
                FlagColumns = Column;
                _columnWidth = columnWidth * (Column - 1) - 0.31;
              }
              else
                _columnWidth = -0.05;

              FirstColumnWidth = -0.05;
            }
            else if (LabelSizeID == 4)//Avery 5371 template
            {
              if (Column != 1) {
                FlagColumns = Column;
                _columnWidth = columnWidth * (Column - 1) - 0.8;
              }
              else
                _columnWidth = -0.03;

              FirstColumnWidth = -0.03;
            }
            else if (LabelSizeID == 3)//Avery 5095 template
            {
              if (Column != 1) {
                FlagColumns = Column;
                _columnWidth = columnWidth * (Column - 1) - 0.55;
              }
              else
                _columnWidth = -0.07;

              // FirstColumnWidth = -0.07;
              FirstColumnWidth = -0.07;

            }

            if (Row != 1) {
              if (LabelSizeID == 1)//Avery 5167 template
              {
                posY = Row * VerticalPitch;
                posY = posY - 0.4;
                //posY = posY - 9.95;
                // _Height = _Height + 0.6;

              }
              else if (LabelSizeID == 2)//Avery 5160 template
              {
                posY = Row * VerticalPitch;
                posY = posY - 0.95;
                // posY = posY - 9.95;
                // _Height = _Height + 0.4;
              }
              else if (LabelSizeID == 7)//Avery 5163 template
              {
                posY = Row * VerticalPitch;
                posY = posY - 1.94;
                //posY = posY - 9.95;
              }
              else if (LabelSizeID == 9)//Avery 5164 template
              {
                posY = Row * VerticalPitch;
                posY = posY - 3.22;
                //posY = posY -  9.949;
              }
              else if (LabelSizeID == 5)//Avery 5161 template
              {
                posY = Row * VerticalPitch;
                posY = posY - 0.94;
                //posY = posY - 9.281;
                // _Height = _Height + 0.4;
              }
              else if (LabelSizeID == 6)//Avery 5162 template
              {
                posY = Row * VerticalPitch;
                posY = posY - 0.9;
                //posY = posY - 9.95;
              }
              else if (LabelSizeID == 22)//Avery 6576 template
              {
                posY = Row * VerticalPitch;
                posY = posY - 1.2;
                //posY = posY - 9.95;
                // _Height = _Height + 0.3;
              }
              else if (LabelSizeID == 10) //Avery 5389 template
              {
                posY = Row * VerticalPitch;
                posY = posY - 4;
                // posY = posY - 7.95;
              }
              else if (LabelSizeID == 8) //Avery 5384 template
              {
                posY = Row * VerticalPitch;
                posY = posY - 3;
                //posY = posY - 8.95;
              }
              else if (LabelSizeID == 4) //Avery 5371 template
              {
                posY = Row * VerticalPitch;
                posY = posY - 2;
                // posY = posY - 9.95;

              }
              else if (LabelSizeID == 3) //Avery 5095 template
              {
                posY = Row * VerticalPitch;

                if (Row == 2)
                  posY = posY - 2.1;
                else if (Row == 3)
                  posY = posY - 1.95;
                else if (Row == 4)
                  posY = posY - 1.75;
                //posY = posY - 5.632;
                //posY = -1.05;
                // posY =- posY;
              }
            }
            else if (Row == 1) {
              posY = 0.05;

              if (LabelSizeID == 6)//Avery 5162 template
                posY = 0.45;
              else if (LabelSizeID == 10) //Avery 5389 template
                posY = 0.05;
              else if (LabelSizeID == 8) //Avery 5384 template
                posY = 0.04;
            }
            FirstPosy = posY;
          }
          else {

            let countI = 0;
            if (Column == 1) {
              countI = i;
            }
            else if (Column > 1)
              countI = (Column - 1) + i;

            if (countI < Columns) {
              posY = FirstPosy;
            }
            else {
              if (rows == 0) {
                if (LabelSizeID == 1 || LabelSizeID == 2 || LabelSizeID == 7 || LabelSizeID == 9 || LabelSizeID == 5 || LabelSizeID == 22 || LabelSizeID == 4
                  || LabelSizeID == 3)
                  posY = 0.05;
                else if (LabelSizeID == 6)//Avery 5162 template
                  posY = 0.45;
                else if (LabelSizeID == 10) //Avery 5389 template
                  posY = 0.05;
                else if (LabelSizeID == 8) //Avery 5384 template
                  posY = 0.04;
              }
              else
                posY = 0;
            }
          }

          Flags = FlagColumns;

          let CodeHeight = _Height;

          // let Barcode1 = new Stimulsoft.Report.BarCodes.StiBarCode (new Stimulsoft.Base.Drawing.RectangleD(HorizontalMargin + _columnWidth, posY, _Width, CodeHeight));
          // 0.688 + 3.7
          let Barcode1 = new Stimulsoft.Report.BarCodes.StiBarCode(new Stimulsoft.Base.Drawing.RectangleD(HorizontalMargin + _columnWidth, posY, _Width, CodeHeight));
          Barcode1.codeValue = BarcodeValues[i].BarcodeNumber.toString();



          if (!isQR) {
            Barcode1.horAlignment = Stimulsoft.Base.Drawing.StiHorAlignment.Center;
            Barcode1.vertAlignment = Stimulsoft.Base.Drawing.StiVertAlignment.Center;
            Barcode1.width = _Width;
            Barcode1.height = CodeHeight;
            // if(  LabelSizeID == 1  || LabelSizeID == 2 ||  LabelSizeID == 5 || LabelSizeID == 22 )
            // Barcode1.autoScale = true;
            // else
            Barcode1.autoScale = false;
            Barcode1.showLabelText = true;
            if (LabelSizeID == 1)
              Barcode1.barCodeType = new Stimulsoft.Report.BarCodes.StiCode128AutoBarCodeType(10, CodeHeight);
            else
              Barcode1.barCodeType = new Stimulsoft.Report.BarCodes.StiCode128AutoBarCodeType(10, CodeHeight);
          }
          else {
            Barcode1.horAlignment = Stimulsoft.Base.Drawing.StiHorAlignment.Center;
            Barcode1.vertAlignment = Stimulsoft.Base.Drawing.StiVertAlignment.Center;
            Barcode1.autoScale = true;
            Barcode1.showLabelText = true;
            Barcode1.barCodeType = new Stimulsoft.Report.BarCodes.StiQRCodeBarCodeType();
          }

          dataBand.components.add(Barcode1);


          if (LabelSizeID == 5 || LabelSizeID == 6 || LabelSizeID == 7 || LabelSizeID == 9)
            _columnWidth += columnWidth - 0.05;
          else if (LabelSizeID == 2)
            _columnWidth += columnWidth - 0.1;
          else if (LabelSizeID == 1) {
            if (FlagColumns == 2)
              _columnWidth += columnWidth - 0.08;
            else if (FlagColumns == 3)
              _columnWidth += columnWidth - 0.075;
            else
              _columnWidth += columnWidth - 0.095;
          }
          else if (LabelSizeID == 22)
            _columnWidth += columnWidth - 0.195;
          else if (LabelSizeID == 8)
            _columnWidth += columnWidth - 0.24;
          else if (LabelSizeID == 4)
            _columnWidth += columnWidth - 0.75;
          else if (LabelSizeID == 3)
            _columnWidth += columnWidth - 0.48;

          if ((FlagColumns % Columns) == 0) {
            rows = rows + 1;

            _columnWidth = FirstColumnWidth;
            if (i != (BarcodeValues.length - 1)) {
              dataBand = new Stimulsoft.Report.Components.StiDataBand(new Stimulsoft.Base.Drawing.RectangleD(0, 0, _Width, dbHeight));
              dataBand.height = 0.5;
              dataBand.name = "DataBand" + i;
              page.components.add(dataBand);
            }

          }

          if (rows == Rows) {

            pageNumber = pageNumber + 1;
            Flags = 1;
            rows = 0;
          }
          FlagColumns = FlagColumns + 1;
        }
        // }

      }
      else {
        page.margins.top = 0;
        //Create Databand
        let dataBand = new Stimulsoft.Report.Components.StiDataBand();
        let pos = 0;
        let posY = 0;
        let dbHeight = 0;
        dbHeight = VerticalPitch;
        columnWidth = Math.round(columnWidth);
        posY = posY + 0.2;
        let rectX = 0;
        // for(let n = 0; n < NumberOfCopies; n++)
        // {
        for (let i = 0; i < BarcodeValues.length; i++) {

          dataBand = new Stimulsoft.Report.Components.StiDataBand(new Stimulsoft.Base.Drawing.RectangleD(0, 0, _Width, _Height));
          dataBand.name = "DataBand";
          page.components.add(dataBand);


          // if (LabelSizeID == 12)//Zebra 2x1
          //     rectX = -0.034;

          let rectY = 0;
          //let BarcodeHeight = 0.85;
          let BarcodeHeight = _Height;

          // if (LabelSizeID == 11 || LabelSizeID == 21)//Zebra 3x1 || Zebra 3x2
          // {
          //   rectX = -0.02;
          // }
          // else if (LabelSizeID == 12)//Zebra 2x1
          //     rectX = -0.034;
          // else if (LabelSizeID == 13)//Zebra 4x2
          // {
          //        rectX = 0.6;
          //        rectY = rectY + 0.6;
          //       BarcodeHeight = 0.8;
          // }
          // else if (LabelSizeID == 15)//Zebra 1.5x0.5
          // {
          //     rectX = -0.025;
          //     rectY = rectY + 0.1;
          //     BarcodeHeight = 0.65;
          //     _Height = _Height - 0.1;
          // }
          // else if (LabelSizeID == 16)//Zebra 2x1.25
          // {
          //     rectX = -0.034;
          //     BarcodeHeight = 0.9;

          // }
          ///////////////////////////////Bakr////////////////////////////

          //   if (LabelSizeID == 18)//Zebra 4x6
          //   {
          //    rectX = -1;
          //    rectY = -1.4;
          //   }
          //   else if (LabelSizeID == 17)//Zebra 4x2.5
          //   {
          //    rectX = -1;
          //    rectY = 0;
          //   }
          //   else if (LabelSizeID == 13)//Zebra 4x2
          //   {
          //    rectX = -1;
          //    rectY = -0.8;
          //   }
          //   else if (LabelSizeID == 20)//Zebra 3x3
          //   {
          //    rectX = -1;
          //    rectY = -0.4;
          //   }


          // else if (LabelSizeID == 21)// || Zebra 3x2
          //   {
          //     rectX = 3.5;
          //     rectY = -0.4;
          //   }
          //   else  if (LabelSizeID == 11) // Zebra 3x1
          //   {
          //     rectX = -1;
          //     rectY = -0.6;
          //    // BarcodeHeight = 0.6;
          //   }
          //   else if (LabelSizeID == 16)//Zebra 2x1.25
          //   {
          //       // // rectX = -0.034;
          //       // // BarcodeHeight = 0.9;
          //          rectX = -1;
          //          rectY =  -0.7;
          //         BarcodeHeight = 0.5;
          //   }
          //   else if (LabelSizeID == 12)//Zebra 2x1
          //   {
          //    //rectX = -0.034;
          //    rectX = -0.4;
          //    rectY =  -0.4;
          //   BarcodeHeight = 0.5;
          //   }
          //   else if(LabelSizeID == 14)//Zebra 2x0.5
          //   {
          //       rectX = 0.5;
          //       rectY = rectY + 0.5;
          //       BarcodeHeight = 0.2;
          //       // rectX = -1;
          //       // rectY =-0.3;
          //   }
          if (LabelSizeID == 15)//Zebra 1.5x0.5
          {
            rectX = -0.2;

          }


          else if (LabelSizeID == 19) // Zebra 1.25x1
          {
            rectX = 0.1;
            //rectY = rectY + 0.4;
          }

          /////////////////////////////Bakr End ///////////////////////////////
          //BarcodeHeight = 0.8;

          let CodeHeight = _Height;

          let Barcode1 = new Stimulsoft.Report.BarCodes.StiBarCode(new Stimulsoft.Base.Drawing.RectangleD(rectX, rectY, columnWidth, _Height));
          Barcode1.codeValue = BarcodeValues[i].BarcodeNumber.toString();


          if (!isQR) {
            // Barcode1.left = -0.10
            // Barcode1.top = -0.61
            // Barcode1.left = 0;
            // Barcode1.top = 0;
            // Barcode1.width = 4.7 // bar code page width size
            // Barcode1.height = 1.85 // bar code page height size
            // BarcodeHeight = 1.2 // bar code columns height


            Barcode1.horAlignment = Stimulsoft.Base.Drawing.StiHorAlignment.Center;
            Barcode1.vertAlignment = Stimulsoft.Base.Drawing.StiVertAlignment.Center;


            if (LabelSizeID == 14 || LabelSizeID == 15 || LabelSizeID == 19) {
              //Barcode1.autoScale = true;
              //    Barcode1.width = 4.7 // bar code page width size
              //  Barcode1.height = 1.85 // bar code page height size
              BarcodeHeight = 0.2;
              //  Barcode1.font = new Stimulsoft.System.Drawing.Font("Arial", 4);
            }
            if (!LabelSizeID)
              BarcodeHeight = _Height;
            // else
            Barcode1.autoScale = false;
            Barcode1.showLabelText = true;

            Barcode1.barCodeType = new Stimulsoft.Report.BarCodes.StiCode128AutoBarCodeType(10, BarcodeHeight);
          }
          else {
            Barcode1.horAlignment = Stimulsoft.Base.Drawing.StiHorAlignment.Center;
            Barcode1.vertAlignment = Stimulsoft.Base.Drawing.StiVertAlignment.Center;
            Barcode1.autoScale = true;
            Barcode1.showLabelText = true;
            Barcode1.barCodeType = new Stimulsoft.Report.BarCodes.StiCode128AutoBarCodeType();
          }

          dataBand.components.add(Barcode1);
          posY = (posY + _Height / 2) - 0.2;
          // rectY += _Height;
          let dataText3 = new Stimulsoft.Report.Components.StiText(new Stimulsoft.Base.Drawing.RectangleD((pos - columnWidth), 0, columnWidth, 0.5));
          dataText3.text = "Count: {Count()}";

          this.stimulsoftReport.pages.getByIndex(0).orientation = Stimulsoft.Report.Components.StiPageOrientation.Portrait;
        }
        //}

      }
    }




    this.viewer.report = this.stimulsoftReport;
    this.maximizeWindow.emit();
    this.viewer.renderHtml('viewer');
  }
  public openReportBarcodeLabelWithReportDefinitionWithoutReportObject(response: any, reportDefinition: any) {
    this.dataSet = new Stimulsoft.System.Data.DataSet('DataSet');
    this.stimulsoftReport = new Stimulsoft.Report.StiReport();
    if (reportDefinition) {
      this.stimulsoftReport.loadEncryptedReport(
        reportDefinition,
        environment.reportsKey
      );
    }

    if (this.barcodeModel.Row > 1 || this.barcodeModel.Column > 1) {
      response = this.SkipRowsAndColumns(response, this.barcodeModel.Row, this.barcodeModel.Column, this.barcodeModel.LabelSize.columns)
    }
    this.dataSet.readJson(response);
    this.options.toolbar.visible = true;
    this.stimulsoftReport.pages.getByIndex(0).orientation = Stimulsoft.Report.Components.StiPageOrientation.Portrait;
    this.stimulsoftReport.regData(this.dataSet.dataSetName, '', this.dataSet);
    this.stimulsoftReport.dictionary.synchronize();
    this.viewer.report = this.stimulsoftReport;
    this.maximizeWindow.emit();
    this.viewer.renderHtml('viewer');



  }
  public openReportBarcodeLabelWithReportDefinition(reportObject: any, response: any) {

    if (reportObject.ReportObj.definition) {
      this.stimulsoftReport.loadEncryptedReport(
        reportObject.ReportObj.definition,
        environment.reportsKey
      );
    }

    if (this.barcodeModel.Row > 1 || this.barcodeModel.Column > 1) {
      response = this.SkipRowsAndColumns(response, this.barcodeModel.Row, this.barcodeModel.Column, this.barcodeModel.LabelSize.columns)
    }
    var LabelSize = this.barcodeModel.LabelSize;
    var page = this.stimulsoftReport.pages.getByIndex(0);
    let Zebra = false;

    if ((LabelSize.Id >= 11 && LabelSize.id < 22) || !LabelSize.id)
      Zebra = true;



    if (Zebra == false) {
      if (this.barcodeModel.numberOfCopy > 1)
        response = this.HandleAveryLabelSizeForMultipleCopies(response, this.barcodeModel.numberOfCopy);
    }
    else
      page._numberOfCopies = this.barcodeModel.numberOfCopy;
    this.dataSet.readJson(response);
    this.options.toolbar.visible = true;
    this.stimulsoftReport.pages.getByIndex(0).orientation = Stimulsoft.Report.Components.StiPageOrientation.Portrait;
    this.stimulsoftReport.regData(this.dataSet.dataSetName, '', this.dataSet);
    this.stimulsoftReport.dictionary.synchronize();
    this.viewer.report = this.stimulsoftReport;
    this.maximizeWindow.emit();
    this.viewer.renderHtml('viewer');



  }
  public openReportBarcodeLabelWithReportDefinitionForEditBarcode(reportObject: any, response: any) {




    this.dataSetFinal = new Stimulsoft.System.Data.DataSet('DataSet');
    if (reportObject.ReportObj.definition) {
      this.stimulsoftReport.loadEncryptedReport(
        reportObject.ReportObj.definition,
        environment.reportsKey
      );
    }
    setTimeout(() => {


      if ((this.barcodeModel.Row > 1 || this.barcodeModel.Column > 1) && this.barcodeModel.LabelSize) {
        response = this.SkipRowsAndColumns(response, this.barcodeModel.Row, this.barcodeModel.Column, this.barcodeModel.LabelSize.columns);
      }
      var LabelSize = this.barcodeModel.LabelSize || { columns: 1, width: 2, height: 1, pageWidth: 2, pageHeight: 1 };
      var page = this.stimulsoftReport.pages.getByIndex(0);
      page._numberOfCopies = this.barcodeModel.numberOfCopy;
      var databandToUpdate = page.components.list.find((component: any) => {
        return component &&
          component.name === 'DataBand';
      }) ?? {};
      var NewSelectedFields = false;
      var ListFieldNames: string[] = [];
      var ListBarcodeFieldNames: string[] = [];
      if (databandToUpdate) {
        this._reportObject.selectedFields.forEach((element: any) => {
          if (!element.title.includes("(barcode image)")) {
            var dataTextlabel = element.field.includes(".") || this.hasWhiteSpace(element.field) ? "[" + element.field + "]" : element.field;
            dataTextlabel = "{root." + dataTextlabel + "}";
            var ExistDataBand = databandToUpdate.components.list.find((x: any) => x.name.includes('DT') && x.text == dataTextlabel)
            if (!ExistDataBand)
              NewSelectedFields = true;
            ListFieldNames.push(dataTextlabel);
          }

          if (element.title.includes("(barcode image)")) {
            var dataTextlabel = element.field.includes(".") || this.hasWhiteSpace(element.field) ? "[" + element.field + "]" : element.field;
            dataTextlabel = "{root." + dataTextlabel + "}";
            var ExistDataBand = databandToUpdate.components.list.find((x: any) => x.name.includes('DataText') && x.code == dataTextlabel);
            if (!ExistDataBand)
              NewSelectedFields = true;
            ListBarcodeFieldNames.push(dataTextlabel);
          }


        });
      }


      // Check Removed Selected Fields That Exist in Databand
      if (databandToUpdate)
        databandToUpdate.components.list = databandToUpdate.components.list.filter((x: any) => (x.name.includes('DT') && ListFieldNames.includes(x.text))
          || (x.name.includes('DataText') && ListBarcodeFieldNames.includes(x.code)));

      let LabelSizeChanged = false;
      // Create Databand
      if (this.barcodeModel?.savedLabelSize && this.barcodeModel?.LabelSize) {
        if (!this.barcodeModel.savedLabelSize.id && !this.barcodeModel.LabelSize.id &&
          (this.barcodeModel.savedLabelSize.width != this.barcodeModel.LabelSize.width
            || this.barcodeModel.savedLabelSize.height != this.barcodeModel.LabelSize.height)) // changed width or height of custom size
        {
          LabelSizeChanged = true;
        }
        else if (this.barcodeModel.savedLabelSize.id != this.barcodeModel.LabelSize.id) // Changed Size of system label size
        {
          LabelSizeChanged = true;
        }
      }
      if (LabelSizeChanged) {
        page.components.remove(databandToUpdate);
        // Create Databand
        databandToUpdate = new Stimulsoft.Report.Components.StiDataBand();
        databandToUpdate.dataSourceName = "root";
        databandToUpdate.height = page.height;
        databandToUpdate.name = "DataBand";

        if (this.barcodeModel.LabelSizeID) // Not Custom Size
        {
          databandToUpdate.columns = LabelSize.columns;
          databandToUpdate.columnWidth = LabelSize.width;
          databandToUpdate.columnGaps = LabelSize.columnGaps;
        }
        page.components.add(databandToUpdate);
      }


      if (NewSelectedFields || LabelSizeChanged == true) {
        this.stimulsoftReport.dictionary.databases.clear();
        this.stimulsoftReport.dictionary.dataSources.clear();
        //this.stimulsoftReport.dictionary.databases.add(response);
        this.createReportbarcodePreviewWithReportDefinition(response,
          this.barcodeModel.LabelSizeID,
          this.barcodeModel.Row,
          this.barcodeModel.Column,
          null,
          this.barcodeModel.LabelSize,
          this.barcodeModel.isQr ? this.barcodeModel.isQr : false);

        //  this.stimulsoftReport.regData(this.dataSet.dataSetName, '', this.dataSetFinal);
        //  page.components.add(databandToUpdate);
      }
      else {



        if (response && response.length > 0) {
          // limit to 20 rows displayed on the page.
          response = response.slice(0, 20);
          var mappedResponse: any[] = [];
          response.forEach((item: any) => {
            var rowObj: any = { ...item };
            Object.keys(item).forEach(key => {
              rowObj[key + "(barcode image)"] = item[key];
              rowObj[key + " (barcode image)"] = item[key];
            });
            mappedResponse.push(rowObj);
          });
          this.dataSet.readJson(mappedResponse);
          this.stimulsoftReport.regData(this.dataSet.dataSetName, '', this.dataSet);
          this.returnDefinition.emit(reportObject.ReportObj.definition);
        }
      }



      this.options.toolbar.visible = true;
      page.invokeRendering();
      this._windowMode = true;
      this.options.toolbar.visible = true;
      this.options.toolbar.zoom = 0;

      this.stimulsoftReport.pages.getByIndex(0).orientation = Stimulsoft.Report.Components.StiPageOrientation.Portrait;

      this.stimulsoftReport.dictionary.synchronize();
      //     this.viewer = new Stimulsoft.Viewer.StiViewer(
      //     this.options,
      //     'StiViewer',
      //     false
      // );
      this.viewer.report = this.stimulsoftReport;
      var viewerExists = document.getElementById("viewer");
      if (!viewerExists) {
        //alert("Viewer Not Loaded");
        //alert(this.viewerFileLoaded);
        setTimeout(() => {
          this.opened = false;
          // this.viewer.renderHtml('viewer');

        }, 1000)
      }
      else {
        this.viewer.renderHtml('viewer');
      }

      // if(reportObject.ReportObj.definition){
      //   this.stimulsoftReport.loadEncryptedReport(
      //     reportObject.ReportObj.definition,
      //       environment.reportsKey
      //   );}
    }, 300);


    //this.maximizeWindow.emit();




  }



  SkipRowsAndColumns(data: any[], SkipRows: number, SkipColumns: number, LabelSizeColumns: number) {
    let NumberOfEmptyFields = 0;
    const emptyRow: any = {};
    if (SkipColumns > 1) {
      SkipColumns -= 1
      NumberOfEmptyFields += SkipColumns;
    }


    if (SkipRows > 1) {
      SkipRows -= 1;
      NumberOfEmptyFields += (SkipRows * LabelSizeColumns);
    }
    for (let i = 1; i <= NumberOfEmptyFields; i++) {
      data.unshift(emptyRow);
    }
    return data;
  }

  initStimulsoft() {
    Stimulsoft.Base.StiLicense.key =
      '6vJhGtLLLz2GNviWmUTrhSqnOItdDwjBylQzQcAOiHkUqG1JqVi9xF1CsQtSylmNCw08f5US/nThDcH2mIyIhcb9q2' +
      'eL238CYd2WruGTJRQWTjv4Ojri9sZfpmunjsBAwTcJRB+7bLz0yAVCU6zESyCSrqmTsZGqSSjXhq82ybmFzAFUskAo' +
      '4HStx+kugphgl4gcDP0VI2kgHB6uQSOD2Xh8X+fmtkH1Q6RMplr+plgH0lQ35cSNk7kDJvc07nTPGVv+ixfOJYHyWO' +
      'o+A6M93S04A7HjpQFnJHCQqzJ7lJ3ZO9heRh2Vt5VBfUJoQZIFTpTNCAvXKZ6FmbFtIa8lKG0CGWFBJjDFkh6e6yVf' +
      'IRPFT48DDBGyC1ZZXHFTiCSxTxx9Rn+ZQrLDgvhZa4YFVIBm0Rrekr67eVHUqXpL7IiQA6kbCkJ/LZ6LCJwEL0TbBn' +
      'RWDfcx/r65mXVC/HoS+KZ3MWfB1fqZmiLfeWjTXXvnE3LjxgJYGobOqvdZns8d9c/Xq+cZtW6/wjnZL6SrHSjaUJPc' +
      'rLgViTggF/EzQGigT6qbzY1Cf5YNhWCuYaN+ou0vG9LVmMSR6oPxc5eHphDFlzEVgUHZWeyGlX0AVp7HVFVWUiJevw' +
      '9NbBkdYnR+0Iqs9pwBbvH3fgbFM8C9eyWM41wmJl16/jqohlJZHuw=';

    this.stimulsoftReport = new Stimulsoft.Report.StiReport();
    this.options = new Stimulsoft.Viewer.StiViewerOptions();
  }

  private updateReportLogoAndAddress() {
    var findComponent = function (parent: any, name: string): any {
      if (!parent || !parent.components || !parent.components.list) return null;
      for (var i = 0; i < parent.components.list.length; i++) {
        var comp = parent.components.list[i];
        if (comp && comp.name === name) return comp;
        var found = findComponent(comp, name);
        if (found) return found;
      }
      return null;
    };

    var page = this.stimulsoftReport.pages.getByIndex(0);
    if (page) {
      if (this._siteLogoUrl) {
        var logoComponent = findComponent(page, 'TitleLogo');
        if (logoComponent) {
          logoComponent.imageURL = this._siteLogoUrl;
          logoComponent.printOn = Stimulsoft.Report.Components.StiPrintOnType.OnlyFirstPage;
        }
      }
      if (this._siteAddress || this._siteName) {
        var addressComponent = findComponent(page, 'TitleAddress');
        if (addressComponent) {
          var addr = (this._siteName ? this._siteName + "\n" : "") + (this._siteAddress1 || this._siteAddress || "");
          var addr2 = this._siteAddress2 ? "\n" + this._siteAddress2 : "";
          var cityStateZip = (this._siteCity || this._siteState || this._siteZip) ? "\n" + [this._siteCity, this._siteState, this._siteZip].filter(Boolean).join(" ") : "";
          var country = this._siteCountry ? "\n" + this._siteCountry : "";
          addressComponent.text = addr + addr2 + cityStateZip + country;
        }
      }
    }

    var addressLogoData = [
      {
        SiteName: this._siteName || "",
        SiteAddress: this._siteAddress || this._siteName || "",
        Address1: this._siteAddress1,
        Address2: this._siteAddress2,
        City: this._siteCity,
        State: this._siteState,
        Zip: this._siteZip,
        Country: this._siteCountry,
        Logo: this._siteLogoUrl
      }
    ];
    var addressLogoDataSet = new Stimulsoft.System.Data.DataSet("AddressLogoDataSet");
    addressLogoDataSet.readJson({ AddressLogoDataSet: addressLogoData });
    if (addressLogoDataSet.tables.list && addressLogoDataSet.tables.list[0]) {
      addressLogoDataSet.tables.list[0].tableName = "AddressLogoDataSet";
    }
    this.stimulsoftReport.regData("AddressLogoDataSet", "AddressLogoDataSet", addressLogoDataSet);
  }

  public openReport(res: Array<any>, previewMode: boolean = false) {
    this.allReportData = res;
    this.dataSet.readJson(res);
    this.stimulsoftReport.regData(this.dataSet.dataSetName, '', this.dataSet);
    this.stimulsoftReport.dictionary.synchronize();

    this.updateReportLogoAndAddress();

    this.viewer.report = this.stimulsoftReport;

    //const allComponents = this.stimulsoftReport.pages[0].components;
    this.maximizeWindow.emit();
    this.viewer.renderHtml('viewer');
  }

  // Forecast Functions
  public onProvidedDateChange(value: Date): void {
    this.providedDateValue = value;
  }

  public onForecastDateChange(value: Date): void {
    this.ForecastDateValue = value;
  }

  close(result: string): void {
    if (result == 'no') {
      this.opened = false;
      var config = this.editForm.value;
      config.providedDate = this.providedDateValue;
      config.ForecastDate = this.ForecastDateValue;
      this._reportService.GetForecastMonthToMonth(config)
        .subscribe(
          (response: any) => {
            this.openReport(response as Array<any>);
          }
        );

    } else {
      this.opened = false;
      this.closeForm.emit();
    }
  }

  GetDistinctSelectFieldsString(StringList: any) {
    let StringListArray = [];
    let DistinctStringArray: any = [];
    StringListArray = StringList.split(",");
    StringListArray.forEach((element: any) => {
      if (!DistinctStringArray.find((x: any) => x == element) && element)
        DistinctStringArray.push(element);
    });
    let DistinctString = DistinctStringArray.join(",");
    return DistinctString;
  }
  hasWhiteSpace(s: any) {
    const whitespaceChars = [' ', '\t', '\n'];
    return whitespaceChars.some(char => s.includes(char));
  }
}

